// // import React, { useState, useEffect, useCallback } from "react";
// // import Sidebar from "./Sidebar";
// // import Footer2 from './Footer2';
// // // ==== CONFIG ====
// // const GET_OFFLINE_TICKET_API = process.env.REACT_APP_HOTEL_TICKET_API;

// // // Is API mein sirf ek transactionId ka record milta hai (list endpoint nahi hai),
// // // isliye "history" banane ke liye hum ek ID-range par isi API ko parallel call
// // // karte hain aur jo bhi valid response aaye unse table banate hain.
// // // Jab bhi real hotel booking LIST API mil jaye, bas loadBookings() function
// // // ko us API se replace kar dena — baaki poora UI waisa hi kaam karega.
// // const DEFAULT_FROM_ID = 20988;
// // const DEFAULT_TO_ID = 21010;

// // const badgeClass = {
// //   Confirmed: "hbh-badge hbh-badge-booked",
// //   Pending: "hbh-badge hbh-badge-pending",
// //   Cancelled: "hbh-badge hbh-badge-cancelled",
// // };

// // const formatDate = (isoStr) => {
// //   if (!isoStr || isoStr.startsWith("0001")) return "-";
// //   const d = new Date(isoStr);
// //   if (isNaN(d.getTime())) return "-";
// //   return d.toLocaleDateString("en-GB", {
// //     day: "2-digit",
// //     month: "short",
// //     year: "numeric",
// //   });
// // };

// // const getStatusLabel = (bookingStatus) => {
// //   if (bookingStatus === 1) return "Confirmed";
// //   if (bookingStatus === 0) return "Pending";
// //   return "Cancelled";
// // };

// // // ==== CSS (inline, isi file ke andar) ====
// // const HBH_STYLES = `
// // .hbh-page {
// //   min-height: 100vh;
// //   background: #f3f5f9;
// //   /* Sidebar fixed-positioned hai (~190px wide), isliye left padding
// //      usi jitni di hai taaki content uske peeche na chhupe.
// //      Agar Sidebar collapse/expand hota hai to yahan value adjust karna. */
// //   padding: 24px 24px 24px 214px;
// //   font-family: "Segoe UI", Roboto, Arial, sans-serif;
// //   color: #1e293b;
// //   box-sizing: border-box;
// // }
// // .hbh-header {
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   background: #eef1f6;
// //   border-radius: 14px;
// //   padding: 22px 26px;
// //   margin-bottom: 20px;
// //   flex-wrap: wrap;
// //   gap: 16px;
// // }
// // .hbh-header h1 {
// //   font-size: 24px;
// //   font-weight: 700;
// //   margin: 0;
// //   color: #0f172a;
// // }
// // .hbh-header p {
// //   font-size: 13px;
// //   color: #64748b;
// //   margin: 4px 0 0;
// // }
// // .hbh-stats {
// //   display: flex;
// //   gap: 12px;
// // }
// // .hbh-stat-card {
// //   background: #ffffff;
// //   border-radius: 10px;
// //   padding: 8px 20px;
// //   text-align: center;
// //   box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
// //   min-width: 80px;
// // }
// // .hbh-stat-label {
// //   font-size: 11px;
// //   letter-spacing: 0.05em;
// //   color: #94a3b8;
// //   font-weight: 600;
// // }
// // .hbh-stat-value {
// //   font-size: 20px;
// //   font-weight: 700;
// // }
// // .hbh-stat-value.total { color: #2563eb; }
// // .hbh-stat-value.booked { color: #16a34a; }
// // .hbh-stat-value.pending { color: #d97706; }
// // .hbh-card {
// //   background: #ffffff;
// //   border-radius: 14px;
// //   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
// //   margin-bottom: 20px;
// // }
// // .hbh-filter-card {
// //   padding: 22px 26px;
// // }
// // .hbh-filter-title {
// //   font-size: 11px;
// //   letter-spacing: 0.05em;
// //   color: #94a3b8;
// //   font-weight: 700;
// //   margin-bottom: 16px;
// // }
// // .hbh-filter-row {
// //   display: flex;
// //   align-items: flex-end;
// //   gap: 16px;
// //   flex-wrap: wrap;
// // }
// // .hbh-field {
// //   display: flex;
// //   flex-direction: column;
// //   gap: 6px;
// // }
// // .hbh-field label {
// //   font-size: 13px;
// //   font-weight: 600;
// //   color: #334155;
// // }
// // .hbh-field input,
// // .hbh-field select {
// //   border: 1px solid #e2e8f0;
// //   border-radius: 8px;
// //   padding: 9px 12px;
// //   font-size: 13px;
// //   color: #1e293b;
// //   outline: none;
// //   min-width: 150px;
// //   background: #fff;
// // }
// // .hbh-field input:focus,
// // .hbh-field select:focus {
// //   border-color: #2563eb;
// //   box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
// // }
// // .hbh-field input::placeholder {
// //   color: #b8c2d1;
// // }
// // .hbh-actions {
// //   display: flex;
// //   gap: 10px;
// //   margin-left: auto;
// // }
// // .hbh-btn {
// //   border: none;
// //   border-radius: 8px;
// //   padding: 9px 16px;
// //   font-size: 13px;
// //   font-weight: 600;
// //   cursor: pointer;
// //   display: inline-flex;
// //   align-items: center;
// //   gap: 6px;
// //   white-space: nowrap;
// // }
// // .hbh-btn:disabled {
// //   opacity: 0.6;
// //   cursor: not-allowed;
// // }
// // .hbh-btn-primary {
// //   background: #2563eb;
// //   color: #fff;
// // }
// // .hbh-btn-primary:hover:not(:disabled) {
// //   background: #1d4ed8;
// // }
// // .hbh-btn-outline {
// //   background: #fff;
// //   border: 1px solid #e2e8f0;
// //   color: #475569;
// // }
// // .hbh-btn-outline:hover:not(:disabled) {
// //   background: #f8fafc;
// // }
// // .hbh-table-card {
// //   overflow: hidden;
// // }
// // .hbh-table-header {
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   padding: 16px 26px;
// // }
// // .hbh-table-count {
// //   font-size: 13px;
// //   color: #334155;
// // }
// // .hbh-table-count b {
// //   font-weight: 700;
// // }
// // .hbh-table-hint {
// //   font-size: 12px;
// //   color: #b8c2d1;
// // }
// // .hbh-table-wrap {
// //   overflow-x: auto;
// // }
// // .hbh-table {
// //   width: 100%;
// //   border-collapse: collapse;
// //   font-size: 13px;
// // }
// // .hbh-table thead tr {
// //   border-top: 1px solid #f1f5f9;
// //   border-bottom: 1px solid #f1f5f9;
// //   text-align: left;
// // }
// // .hbh-table th {
// //   padding: 12px 20px;
// //   font-size: 11px;
// //   letter-spacing: 0.04em;
// //   color: #94a3b8;
// //   font-weight: 600;
// //   white-space: nowrap;
// // }
// // .hbh-table td {
// //   padding: 14px 20px;
// //   border-bottom: 1px solid #f8fafc;
// //   color: #334155;
// //   white-space: nowrap;
// // }
// // .hbh-table tbody tr:hover {
// //   background: #f8fafc;
// // }
// // .hbh-idx {
// //   color: #94a3b8;
// // }
// // .hbh-hotel-name {
// //   font-weight: 600;
// //   color: #1e293b;
// // }
// // .hbh-booking-link {
// //   color: #2563eb;
// //   font-weight: 600;
// // }
// // .hbh-badge {
// //   display: inline-block;
// //   padding: 4px 12px;
// //   border-radius: 999px;
// //   font-size: 12px;
// //   font-weight: 600;
// // }
// // .hbh-badge-booked {
// //   background: #d1fae5;
// //   color: #047857;
// // }
// // .hbh-badge-pending {
// //   background: #fef3c7;
// //   color: #b45309;
// // }
// // .hbh-badge-cancelled {
// //   background: #fee2e2;
// //   color: #b91c1c;
// // }
// // .hbh-row-btn {
// //   border-radius: 6px;
// //   padding: 6px 14px;
// //   font-size: 12px;
// //   font-weight: 600;
// //   cursor: pointer;
// //   border: 1px solid transparent;
// // }
// // .hbh-btn-ticket {
// //   background: #f1f5f9;
// //   color: #334155;
// // }
// // .hbh-btn-ticket:hover {
// //   background: #e2e8f0;
// // }
// // .hbh-empty {
// //   text-align: center;
// //   padding: 40px;
// //   color: #94a3b8;
// // }
// // .hbh-modal-overlay {
// //   position: fixed;
// //   inset: 0;
// //   background: rgba(15, 23, 42, 0.45);
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   z-index: 999;
// //   padding: 16px;
// // }
// // .hbh-modal {
// //   background: #fff;
// //   border-radius: 14px;
// //   width: 100%;
// //   max-width: 640px;
// //   max-height: 90vh;
// //   overflow-y: auto;
// //   box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
// // }
// // .hbh-modal-header {
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   padding: 18px 24px;
// //   border-bottom: 1px solid #f1f5f9;
// // }
// // .hbh-modal-header h2 {
// //   font-size: 16px;
// //   margin: 0;
// //   color: #1e293b;
// // }
// // .hbh-modal-close {
// //   border: none;
// //   background: none;
// //   font-size: 22px;
// //   line-height: 1;
// //   color: #94a3b8;
// //   cursor: pointer;
// // }
// // .hbh-modal-close:hover {
// //   color: #475569;
// // }
// // .hbh-modal-body {
// //   padding: 22px 24px;
// // }
// // .hbh-modal-loading,
// // .hbh-modal-error {
// //   text-align: center;
// //   padding: 40px 0;
// //   color: #94a3b8;
// // }
// // .hbh-modal-error {
// //   color: #dc2626;
// // }
// // .hbh-modal-section {
// //   border-top: 1px solid #f1f5f9;
// //   padding-top: 16px;
// //   margin-top: 16px;
// // }
// // .hbh-modal-section:first-child {
// //   border-top: none;
// //   padding-top: 0;
// //   margin-top: 0;
// // }
// // .hbh-modal-label {
// //   font-size: 11px;
// //   color: #94a3b8;
// //   margin-bottom: 4px;
// // }
// // .hbh-modal-value {
// //   font-weight: 600;
// //   color: #1e293b;
// //   font-size: 14px;
// // }
// // .hbh-modal-sub {
// //   font-size: 13px;
// //   color: #64748b;
// //   margin-top: 2px;
// // }
// // .hbh-modal-top-row {
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// // }
// // .hbh-modal-grid {
// //   display: grid;
// //   grid-template-columns: 1fr 1fr;
// //   gap: 14px;
// // }
// // .hbh-modal-price-row {
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// // }
// // .hbh-modal-price {
// //   font-size: 20px;
// //   font-weight: 700;
// //   color: #2563eb;
// // }
// // .hbh-page-loading {
// //   text-align: center;
// //   padding: 60px 20px;
// //   color: #64748b;
// //   font-size: 14px;
// // }
// // /* ==== Voucher-style ticket modal ==== */
// // .hbh-voucher {
// //   background: #fff;
// // }
// // .hbh-voucher-topbar {
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   padding: 16px 24px;
// //   border-bottom: 1px solid #f1f5f9;
// // }
// // .hbh-voucher-brand {
// //   font-size: 18px;
// //   font-weight: 800;
// //   color: #1e293b;
// //   letter-spacing: 0.02em;
// // }
// // .hbh-voucher-brand span {
// //   color: #2563eb;
// // }
// // .hbh-voucher-qr {
// //   width: 56px;
// //   height: 56px;
// //   border: 1px solid #e2e8f0;
// //   border-radius: 6px;
// // }
// // .hbh-voucher-pnr-row {
// //   padding: 14px 24px 0;
// // }
// // .hbh-voucher-pnr {
// //   font-size: 13px;
// //   font-weight: 700;
// //   color: #1e293b;
// // }
// // .hbh-voucher-status {
// //   font-size: 13px;
// //   font-weight: 700;
// //   margin-top: 4px;
// // }
// // .hbh-voucher-status.confirmed { color: #16a34a; }
// // .hbh-voucher-status.pending { color: #d97706; }
// // .hbh-voucher-status.cancelled { color: #dc2626; }
// // .hbh-voucher-box {
// //   margin: 16px 24px 24px;
// //   border: 1px solid #e2e8f0;
// //   border-radius: 10px;
// //   overflow: hidden;
// // }
// // .hbh-voucher-box-head {
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   background: #f8fafc;
// //   padding: 10px 16px;
// //   border-bottom: 1px solid #e2e8f0;
// // }
// // .hbh-voucher-box-head-title {
// //   font-size: 13px;
// //   font-weight: 700;
// //   color: #94a3b8;
// // }
// // .hbh-voucher-box-head-date {
// //   font-size: 12px;
// //   color: #94a3b8;
// // }
// // .hbh-voucher-body {
// //   display: flex;
// //   gap: 16px;
// //   padding: 16px;
// // }
// // .hbh-voucher-details {
// //   flex: 1;
// //   display: grid;
// //   grid-template-columns: 1fr;
// //   gap: 10px;
// // }
// // .hbh-voucher-row {
// //   display: flex;
// //   gap: 8px;
// //   font-size: 13px;
// // }
// // .hbh-voucher-row-label {
// //   min-width: 130px;
// //   font-weight: 700;
// //   color: #1e293b;
// // }
// // .hbh-voucher-row-value {
// //   color: #334155;
// // }
// // .hbh-voucher-booked-by {
// //   width: 150px;
// //   border: 1px solid #e2e8f0;
// //   border-radius: 8px;
// //   padding: 10px;
// //   text-align: center;
// //   font-size: 11px;
// //   color: #64748b;
// //   height: fit-content;
// // }
// // .hbh-voucher-booked-by b {
// //   display: block;
// //   font-size: 11px;
// //   color: #1e293b;
// //   margin-bottom: 6px;
// // }
// // .hbh-voucher-booked-by .txn {
// //   margin-top: 8px;
// //   font-weight: 700;
// //   color: #2563eb;
// //   font-size: 12px;
// //   word-break: break-all;
// // }
// // .hbh-voucher-table-wrap {
// //   padding: 0 16px 16px;
// // }
// // .hbh-voucher-table {
// //   width: 100%;
// //   border-collapse: collapse;
// //   font-size: 12px;
// // }
// // .hbh-voucher-table th {
// //   background: #f8fafc;
// //   text-align: left;
// //   padding: 8px 10px;
// //   border: 1px solid #e2e8f0;
// //   color: #475569;
// //   font-weight: 700;
// // }
// // .hbh-voucher-table td {
// //   padding: 8px 10px;
// //   border: 1px solid #e2e8f0;
// //   color: #334155;
// // }
// // .hbh-voucher-footer {
// //   border-top: 1px solid #f1f5f9;
// //   padding: 20px 24px;
// //   display: grid;
// //   grid-template-columns: repeat(4, 1fr);
// //   gap: 16px;
// // }
// // .hbh-voucher-footer-col h4 {
// //   font-size: 12px;
// //   color: #1e293b;
// //   margin: 0 0 8px;
// // }
// // .hbh-voucher-footer-col a,
// // .hbh-voucher-footer-col p {
// //   display: block;
// //   font-size: 11px;
// //   color: #64748b;
// //   margin-bottom: 6px;
// //   text-decoration: none;
// // }
// // .hbh-voucher-social {
// //   display: flex;
// //   gap: 8px;
// // }
// // .hbh-voucher-social span {
// //   width: 22px;
// //   height: 22px;
// //   border-radius: 50%;
// //   background: #1e293b;
// //   display: inline-flex;
// //   align-items: center;
// //   justify-content: center;
// //   color: #fff;
// //   font-size: 11px;
// // }
// // .hbh-voucher-copyright {
// //   border-top: 1px solid #f1f5f9;
// //   padding: 12px 24px;
// //   display: flex;
// //   align-items: center;
// //   justify-content: space-between;
// //   font-size: 11px;
// //   color: #94a3b8;
// // }
// // @media (max-width: 640px) {
// //   .hbh-page {
// //     padding-left: 24px;
// //   }
// //   .hbh-actions {
// //     margin-left: 0;
// //     width: 100%;
// //   }
// //   .hbh-stats {
// //     width: 100%;
// //     justify-content: space-between;
// //   }
// //   .hbh-voucher-body {
// //     flex-direction: column;
// //   }
// //   .hbh-voucher-booked-by {
// //     width: 100%;
// //   }
// //   .hbh-voucher-footer {
// //     grid-template-columns: 1fr 1fr;
// //   }
// // }
// //   .hbh-logo {
// //   height: 70px;
// //   width: auto;
// //   display: block;
// //   object-fit: contain;
// // }

// // .hbh-voucher-brand {
// //   display: flex;
// //   align-items: center;
// // }
// // `;

// // // Fetch a single ticket by transactionId. Returns null if not found / invalid.
// // async function fetchTicketById(transactionId) {
// //   try {
// //     const res = await fetch(
// //       `${GET_OFFLINE_TICKET_API}?transactionId=${transactionId}`
// //     );
// //     if (!res.ok) return null;
// //     const data = await res.json();
// //     if (!data || !data.HotelName) return null;
// //     return { ...data, TransactionId: data.TransactionId || transactionId };
// //   } catch (err) {
// //     return null;
// //   }
// // }

// // export default function HotelBookingHistory() {
// //   // Transaction ID range background mein fixed hai — API sirf transactionId
// //   // support karti hai (date/list query nahi), isliye range yahi se control hoti hai.
// //   const FETCH_FROM_ID = DEFAULT_FROM_ID;
// //   const FETCH_TO_ID = DEFAULT_TO_ID;

// //   const [fromDate, setFromDate] = useState("");
// //   const [toDate, setToDate] = useState("");
// //   const [bookingIdFilter, setBookingIdFilter] = useState("");
// //   const [status, setStatus] = useState("All Status");

// //   const [bookings, setBookings] = useState([]); // 100% API-fetched, never hardcoded
// //   const [loading, setLoading] = useState(false);
// //   const [loadError, setLoadError] = useState("");

// //   const [ticketModalOpen, setTicketModalOpen] = useState(false);
// //   const [ticketLoading, setTicketLoading] = useState(false);
// //   const [ticketError, setTicketError] = useState("");
// //   const [ticketData, setTicketData] = useState(null);

// //   // ==== FETCH ALL BOOKINGS FROM THE API (range of transactionIds) ====
// //   const loadBookings = useCallback(async (from, to) => {
// //     setLoading(true);
// //     setLoadError("");

// //     const start = Number(from);
// //     const end = Number(to);

// //     const ids = [];
// //     for (let id = start; id <= end; id++) ids.push(id);

// //     try {
// //       const results = await Promise.all(ids.map((id) => fetchTicketById(id)));
// //       const valid = results.filter(Boolean);
// //       setBookings(valid);
// //       if (valid.length === 0) {
// //         setLoadError("Koi booking nahi mili.");
// //       }
// //     } catch (err) {
// //       setLoadError("Bookings load nahi ho paayi. Dobara try karo.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, []);

// //   useEffect(() => {
// //     loadBookings(FETCH_FROM_ID, FETCH_TO_ID);
// //   }, [loadBookings]);

// //   // ==== SEARCH & FILTER (client-side, on already API-fetched data) ====
// //   const filteredBookings = bookings.filter((b) => {
// //     const matchesBookingId = bookingIdFilter.trim()
// //       ? (b.TicketNumber || "")
// //           .toLowerCase()
// //           .includes(bookingIdFilter.trim().toLowerCase())
// //       : true;

// //     const matchesStatus =
// //       status === "All Status"
// //         ? true
// //         : getStatusLabel(b.BookingStatus) === status;

// //     let matchesDate = true;
// //     if (b.CheckinDate && !b.CheckinDate.startsWith("0001")) {
// //       const checkin = new Date(b.CheckinDate);
// //       if (fromDate) matchesDate = matchesDate && checkin >= new Date(fromDate);
// //       if (toDate) matchesDate = matchesDate && checkin <= new Date(toDate);
// //     }

// //     return matchesBookingId && matchesStatus && matchesDate;
// //   });

// //   const totalCount = filteredBookings.length;
// //   const bookedCount = filteredBookings.filter(
// //     (b) => getStatusLabel(b.BookingStatus) === "Confirmed"
// //   ).length;
// //   const pendingCount = filteredBookings.filter(
// //     (b) => getStatusLabel(b.BookingStatus) === "Pending"
// //   ).length;

// //   const handleSearch = () => {
// //     // Filters client-side hain (state change pe apne aap apply ho jaate hain),
// //     // Search button latest data bhi API se re-fetch kar leta hai.
// //     loadBookings(FETCH_FROM_ID, FETCH_TO_ID);
// //   };

// //   const handleReset = () => {
// //     setFromDate("");
// //     setToDate("");
// //     setBookingIdFilter("");
// //     setStatus("All Status");
// //     loadBookings(FETCH_FROM_ID, FETCH_TO_ID);
// //   };

// //   // ==== VIEW TICKET (re-fetches fresh data from the API on click) ====
// //   const handleViewTicket = async (transactionId) => {
// //     setTicketModalOpen(true);
// //     setTicketLoading(true);
// //     setTicketError("");
// //     setTicketData(null);

// //     const data = await fetchTicketById(transactionId);
// //     if (data) {
// //       setTicketData(data);
// //     } else {
// //       setTicketError("Ticket load nahi ho paayi. Dobara try karo.");
// //     }
// //     setTicketLoading(false);
// //   };

// //   const closeModal = () => {
// //     setTicketModalOpen(false);
// //     setTicketData(null);
// //     setTicketError("");
// //   };

// //   // ==== EXPORT EXCEL (CSV) — from real fetched data only ====
// //   const handleExportExcel = () => {
// //     const headers = [
// //       "#",
// //       "Hotel Name",
// //       "Booking ID",
// //       "Passenger",
// //       "Checkin",
// //       "Checkout",
// //       "Status",
// //     ];
// //     const rows = filteredBookings.map((b, idx) => [
// //       idx + 1,
// //       b.HotelName,
// //       b.TicketNumber,
// //       b.PassengerName,
// //       formatDate(b.CheckinDate),
// //       formatDate(b.CheckoutDate),
// //       getStatusLabel(b.BookingStatus),
// //     ]);

// //     const csvContent =
// //       headers.join(",") +
// //       "\n" +
// //       rows.map((r) => r.map((cell) => `"${cell ?? ""}"`).join(",")).join("\n");

// //     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
// //     const link = document.createElement("a");
// //     link.href = URL.createObjectURL(blob);
// //     link.download = "hotel_booking_history.csv";
// //     link.click();
// //   };

// //   return (
// //     <div className="hbh-page">
// //       <Sidebar/>
// //       <style>{HBH_STYLES}</style>

// //       {/* Header */}
// //       <div className="hbh-header">
// //         <div>
// //           <h1>Hotel Bookings</h1>
// //           <p>Real-time overview of all hotel reservations</p>
// //         </div>
// //         <div className="hbh-stats">
// //           <div className="hbh-stat-card">
// //             <div className="hbh-stat-label">TOTAL</div>
// //             <div className="hbh-stat-value total">{totalCount}</div>
// //           </div>
// //           <div className="hbh-stat-card">
// //             <div className="hbh-stat-label">BOOKED</div>
// //             <div className="hbh-stat-value booked">{bookedCount}</div>
// //           </div>
// //           <div className="hbh-stat-card">
// //             <div className="hbh-stat-label">PENDING</div>
// //             <div className="hbh-stat-value pending">{pendingCount}</div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Search & Filter */}
// //       <div className="hbh-card hbh-filter-card">
// //         <div className="hbh-filter-title">SEARCH &amp; FILTER</div>
// //         <div className="hbh-filter-row">
// //           <div className="hbh-field">
// //             <label>From Date</label>
// //             <input
// //               type="date"
// //               value={fromDate}
// //               onChange={(e) => setFromDate(e.target.value)}
// //             />
// //           </div>
// //           <div className="hbh-field">
// //             <label>To Date</label>
// //             <input
// //               type="date"
// //               value={toDate}
// //               onChange={(e) => setToDate(e.target.value)}
// //             />
// //           </div>
// //           <div className="hbh-field">
// //             <label>Booking ID</label>
// //             <input
// //               type="text"
// //               placeholder="e.g. TKT-00123"
// //               value={bookingIdFilter}
// //               onChange={(e) => setBookingIdFilter(e.target.value)}
// //             />
// //           </div>
// //           <div className="hbh-field">
// //             <label>Status</label>
// //             <select value={status} onChange={(e) => setStatus(e.target.value)}>
// //               <option>All Status</option>
// //               <option>Confirmed</option>
// //               <option>Pending</option>
// //               <option>Cancelled</option>
// //             </select>
// //           </div>

// //           <div className="hbh-actions">
// //             <button
// //               className="hbh-btn hbh-btn-primary"
// //               onClick={handleExportExcel}
// //               disabled={loading || filteredBookings.length === 0}
// //             >
// //               📊 Export Excel
// //             </button>
// //             <button
// //               className="hbh-btn hbh-btn-primary"
// //               onClick={handleSearch}
// //               disabled={loading}
// //             >
// //               🔍 {loading ? "Searching..." : "Search"}
// //             </button>
// //             <button
// //               className="hbh-btn hbh-btn-outline"
// //               onClick={handleReset}
// //               disabled={loading}
// //             >
// //               Reset
// //             </button>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Table */}
// //       <div className="hbh-card hbh-table-card">
// //         <div className="hbh-table-header">
// //           <div className="hbh-table-count">
// //             <b>{filteredBookings.length}</b> bookings found
// //           </div>
// //           <div className="hbh-table-hint">
// //             Scroll horizontally on smaller screens
// //           </div>
// //         </div>

// //         {loading ? (
// //           <div className="hbh-page-loading">Loading bookings from API...</div>
// //         ) : loadError && filteredBookings.length === 0 ? (
// //           <div className="hbh-page-loading">{loadError}</div>
// //         ) : (
// //           <div className="hbh-table-wrap">
// //             <table className="hbh-table">
// //               <thead>
// //                 <tr>
// //                   <th>#</th>
// //                   <th>HOTEL</th>
// //                   <th>BOOKING ID</th>
// //                   <th>PASSENGER</th>
// //                   <th>CHECKIN</th>
// //                   <th>CHECKOUT</th>
// //                   <th>STATUS</th>
// //                   <th>TICKET</th>
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {filteredBookings.map((b, idx) => (
// //                   <tr key={b.TransactionId || b.TicketNumber || idx}>
// //                     <td className="hbh-idx">{idx + 1}</td>
// //                     <td className="hbh-hotel-name">{b.HotelName}</td>
// //                     <td>
// //                       <span className="hbh-booking-link">
// //                         {b.TicketNumber}
// //                       </span>
// //                     </td>
// //                     <td>{b.PassengerName}</td>
// //                     <td>{formatDate(b.CheckinDate)}</td>
// //                     <td>{formatDate(b.CheckoutDate)}</td>
// //                     <td>
// //                       <span
// //                         className={
// //                           badgeClass[getStatusLabel(b.BookingStatus)] ||
// //                           "hbh-badge hbh-badge-pending"
// //                         }
// //                       >
// //                         {getStatusLabel(b.BookingStatus)}
// //                       </span>
// //                     </td>
// //                     <td>
// //                       <button
// //                         className="hbh-row-btn hbh-btn-ticket"
// //                         onClick={() => handleViewTicket(b.TransactionId)}
// //                       >
// //                         Ticket
// //                       </button>
// //                     </td>
// //                   </tr>
// //                 ))}

// //                 {filteredBookings.length === 0 && (
// //                   <tr>
// //                     <td colSpan={8} className="hbh-empty">
// //                       Koi booking nahi mili.
// //                     </td>
// //                   </tr>
// //                 )}
// //               </tbody>
// //             </table>
// //           </div>
// //         )}
// //       </div>

// //       {/* Ticket Modal — Voucher design */}
// //       {ticketModalOpen && (
// //         <div className="hbh-modal-overlay" onClick={closeModal}>
// //           <div className="hbh-modal hbh-voucher" onClick={(e) => e.stopPropagation()}>
// //             <div className="hbh-modal-header">
// //               <h2>Hotel Voucher</h2>
// //               <button className="hbh-modal-close" onClick={closeModal}>
// //                 &times;
// //               </button>
// //             </div>

// //             {ticketLoading && (
// //               <div className="hbh-modal-loading">Loading ticket...</div>
// //             )}

// //             {ticketError && (
// //               <div className="hbh-modal-error">{ticketError}</div>
// //             )}

// //             {!ticketLoading && !ticketError && ticketData && (
// //               <>
// //                 {/* Top bar: brand + QR placeholder */}
// //              <div className="hbh-voucher-topbar">
// //   <div className="hbh-voucher-brand">
// //     <img
// //       src="/tripji.png"
// //       alt="TripJi Logo"
// //       className="hbh-logo"
// //     />
// //   </div>

// //   <div className="hbh-voucher-qr" />
// // </div>
// //                 {/* PNR + Status */}
// //                 <div className="hbh-voucher-pnr-row">
// //                   <div className="hbh-voucher-pnr">
// //                     Hotel PNR: {ticketData.TicketNumber}
// //                   </div>
// //                   <div
// //                     className={
// //                       "hbh-voucher-status " +
// //                       (getStatusLabel(ticketData.BookingStatus) === "Confirmed"
// //                         ? "confirmed"
// //                         : getStatusLabel(ticketData.BookingStatus) === "Pending"
// //                         ? "pending"
// //                         : "cancelled")
// //                     }
// //                   >
// //                     Status:{" "}
// //                     {getStatusLabel(ticketData.BookingStatus) === "Confirmed"
// //                       ? "Booking Confirmed"
// //                       : getStatusLabel(ticketData.BookingStatus) === "Pending"
// //                       ? "Booking Pending"
// //                       : "Booking Cancelled"}
// //                   </div>
// //                 </div>

// //                 {/* Main details box */}
// //                 <div className="hbh-voucher-box">
// //                   <div className="hbh-voucher-box-head">
// //                     <div className="hbh-voucher-box-head-title">
// //                       Hotel Ticket
// //                     </div>
// //                     <div className="hbh-voucher-box-head-date">
// //                       Booking Date: {formatDate(ticketData.BookingDate)}
// //                     </div>
// //                   </div>

// //                   <div className="hbh-voucher-body">
// //                     <div className="hbh-voucher-details">
// //                       <div className="hbh-voucher-row">
// //                         <div className="hbh-voucher-row-label">
// //                           DESTINATION:
// //                         </div>
// //                         <div className="hbh-voucher-row-value">
// //                           {ticketData.CityName}, {ticketData.CountryName}
// //                         </div>
// //                       </div>
// //                       <div className="hbh-voucher-row">
// //                         <div className="hbh-voucher-row-label">
// //                           HOTEL NAME:
// //                         </div>
// //                         <div className="hbh-voucher-row-value">
// //                           {ticketData.HotelName}
// //                         </div>
// //                       </div>
// //                       <div className="hbh-voucher-row">
// //                         <div className="hbh-voucher-row-label">
// //                           HOTEL ADDRESS:
// //                         </div>
// //                         <div className="hbh-voucher-row-value">
// //                           {ticketData.HotelAddress}
// //                         </div>
// //                       </div>
// //                       <div className="hbh-voucher-row">
// //                         <div className="hbh-voucher-row-label">CHECK IN:</div>
// //                         <div className="hbh-voucher-row-value">
// //                           {formatDate(ticketData.CheckinDate)}
// //                         </div>
// //                       </div>
// //                       <div className="hbh-voucher-row">
// //                         <div className="hbh-voucher-row-label">
// //                           CHECK OUT:
// //                         </div>
// //                         <div className="hbh-voucher-row-value">
// //                           {formatDate(ticketData.CheckoutDate)}
// //                         </div>
// //                       </div>
// //                       <div className="hbh-voucher-row">
// //                         <div className="hbh-voucher-row-label">
// //                           NO. OF ROOMS:
// //                         </div>
// //                         <div className="hbh-voucher-row-value">
// //                           {ticketData.NumberOfRooms}
// //                         </div>
// //                       </div>
// //                       <div className="hbh-voucher-row">
// //                         <div className="hbh-voucher-row-label">ADULTS:</div>
// //                         <div className="hbh-voucher-row-value">
// //                           {ticketData.NumberOfAdults}
// //                         </div>
// //                       </div>
// //                       <div className="hbh-voucher-row">
// //                         <div className="hbh-voucher-row-label">
// //                           CHILDREN:
// //                         </div>
// //                         <div className="hbh-voucher-row-value">
// //                           {ticketData.NumberOfChild}
// //                         </div>
// //                       </div>
// //                     </div>

// //                     <div className="hbh-voucher-booked-by">
// //                       <b>BOOKED BY:</b>
// //                       TripCaliber
// //                       <div className="txn">
// //                         TXN ID: {ticketData.TicketNumber}
// //                       </div>
// //                     </div>
// //                   </div>

// //                   {/* Room table */}
// //                   <div className="hbh-voucher-table-wrap">
// //                     <table className="hbh-voucher-table">
// //                       <thead>
// //                         <tr>
// //                           <th>Room No#</th>
// //                           <th>Room Type/Board</th>
// //                           <th>Guest Name</th>
// //                           <th>Adults</th>
// //                           <th>Children</th>
// //                           <th>Room Rate</th>
// //                         </tr>
// //                       </thead>
// //                       <tbody>
// //                         <tr>
// //                           <td>ROOM 1</td>
// //                           <td>{ticketData.RoomType || "-"}</td>
// //                           <td>{ticketData.PassengerName}</td>
// //                           <td>{ticketData.NumberOfAdults}</td>
// //                           <td>{ticketData.NumberOfChild}</td>
// //                           <td>
// //                             {Number(ticketData.TotalPrice || 0).toLocaleString(
// //                               "en-IN"
// //                             )}
// //                           </td>
// //                         </tr>
// //                       </tbody>
// //                     </table>
// //                   </div>
// //                 </div>

// //                 {/* Footer */}
// //                 <div className="hbh-voucher-footer">
// //                   <div className="hbh-voucher-footer-col">
// //                     <h4>Company</h4>
// //                     <a href="#">About Us</a>
// //                     <a href="#">Blog</a>
// //                     <a href="#">Privacy Policy</a>
// //                     <a href="#">Terms of Use</a>
// //                     <a href="#">Refund &amp; Cancellation Policy</a>
// //                   </div>
// //                   <div className="hbh-voucher-footer-col">
// //                     <h4>Services</h4>
// //                     <a href="#">Flight Booking</a>
// //                     <a href="#">Hotel Booking</a>
// //                   </div>
// //                   <div className="hbh-voucher-footer-col">
// //                     <h4>Help And Support</h4>
// //                     <a href="#">Contact Us</a>
// //                     <a href="#">Agent Login</a>
// //                   </div>
// //                   <div className="hbh-voucher-footer-col">
// //                     <h4>Keep In Touch</h4>
// //                     <div className="hbh-voucher-social">
// //                       <span>f</span>
// //                       <span>x</span>
// //                       <span>in</span>
// //                       <span>yt</span>
// //                     </div>
// //                   </div>
// //                 </div>

// //                 <div className="hbh-voucher-copyright">
// //                   <span>© 2025 - 2026 TripCaliber</span>
// //                   <span>Powered By: Naman Technolab</span>
// //                 </div>
// //               </>
// //             )}
// //           </div>
// //         </div>
// //       )}
// //       <Footer2/>
// //     </div>
// //   );
// // }


// import React, { useState, useEffect, useCallback } from "react";
// import Sidebar from "./Sidebar";
// import Footer2 from './Footer2';
// // ==== CONFIG ====
// const GET_OFFLINE_TICKET_API = process.env.REACT_APP_HOTEL_TICKET_API; // single ticket (voucher modal) ke liye
// const GET_BOOKING_LIST_API = process.env.REACT_APP_HOTEL_BOOKING_LIST_API; // table list ke liye (GetAdminBookingList)
// const UPDATE_BOOKING_API = "https://api.hotel.namantechnolab.com/api/Static/UpdateAdminBooking"; // edit/update ke liye
// // 405 (Method Not Allowed) aaye toh iska matlab backend ne is route pe humara method allow nahi kiya.
// // Network tab -> is request ke Response Headers -> "Allow" header check karo, wahi method yahan daal do.
// // Senior/backend team se bhi confirm kar sakta hai ki ye action [HttpPost] hai ya [HttpPut]/[HttpGet].
// const UPDATE_BOOKING_METHOD = "PUT"; // "POST" fail (405) ho raha tha, isliye PUT try kar rahe — zaroorat pade toh badal dena

// // ==== STATUS MAP for GetAdminBookingList's BookingStatus ====
// // NOTE: Ye list API ka status enum ticket API se ALAG hai (1/4/6 mile the sample response mein,
// // ticket API mein 0/1 tha). Agar mapping galat lage toh yahi values badal dena, baaki sab
// // automatically theek ho jayega.
// const LIST_STATUS_MAP = {
//   1: "Confirmed",
//   4: "Pending",
//   6: "Cancelled",
// };
// const getListStatusLabel = (bookingStatus) =>
//   LIST_STATUS_MAP[bookingStatus] || "Pending";

// // Edit form ke status dropdown ke liye (LIST_STATUS_MAP ke reverse jaisa hi)
// const EDIT_STATUS_OPTIONS = [
//   { value: 1, label: "Confirmed" },
//   { value: 4, label: "Pending" },
//   { value: 6, label: "Cancelled" },
// ];

// // Ticket (voucher) API ka apna status enum — is component ka purana wala, waisa hi rakha hai
// const getTicketStatusLabel = (bookingStatus) => {
//   if (bookingStatus === 1) return "Confirmed";
//   if (bookingStatus === 0) return "Pending";
//   return "Cancelled";
// };

// const badgeClass = {
//   Confirmed: "hbh-badge hbh-badge-booked",
//   Pending: "hbh-badge hbh-badge-pending",
//   Cancelled: "hbh-badge hbh-badge-cancelled",
// };

// const formatDate = (isoStr) => {
//   if (!isoStr || isoStr.startsWith("0001")) return "-";
//   const d = new Date(isoStr);
//   if (isNaN(d.getTime())) return "-";
//   return d.toLocaleDateString("en-GB", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// };

// // Date ko <input type="date"> ke liye yyyy-mm-dd format mein convert karta hai
// const toInputDate = (isoStr) => {
//   if (!isoStr || isoStr.startsWith("0001")) return "";
//   const d = new Date(isoStr);
//   if (isNaN(d.getTime())) return "";
//   return d.toISOString().split("T")[0];
// };

// // Default date range jab page pehli baar load ho (last 30 din)
// const getDefaultDateRange = () => {
//   const to = new Date();
//   const from = new Date();
//   from.setDate(from.getDate() - 30);
//   const fmt = (d) => d.toISOString().split("T")[0];
//   return { from: fmt(from), to: fmt(to) };
// };

// // ==== CSS (inline, isi file ke andar) ====
// const HBH_STYLES = `
// .hbh-page {
//   min-height: 100vh;
//   background: #f3f5f9;
//   /* Sidebar fixed-positioned hai (~190px wide), isliye left padding
//      usi jitni di hai taaki content uske peeche na chhupe.
//      Agar Sidebar collapse/expand hota hai to yahan value adjust karna. */
//   padding: 24px 24px 24px 214px;
//   font-family: "Segoe UI", Roboto, Arial, sans-serif;
//   color: #1e293b;
//   box-sizing: border-box;
// }
// .hbh-header {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   background: #eef1f6;
//   border-radius: 14px;
//   padding: 22px 26px;
//   margin-bottom: 20px;
//   flex-wrap: wrap;
//   gap: 16px;
// }
// .hbh-header h1 {
//   font-size: 24px;
//   font-weight: 700;
//   margin: 0;
//   color: #0f172a;
// }
// .hbh-header p {
//   font-size: 13px;
//   color: #64748b;
//   margin: 4px 0 0;
// }
// .hbh-stats {
//   display: flex;
//   gap: 12px;
// }
// .hbh-stat-card {
//   background: #ffffff;
//   border-radius: 10px;
//   padding: 8px 20px;
//   text-align: center;
//   box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
//   min-width: 80px;
// }
// .hbh-stat-label {
//   font-size: 11px;
//   letter-spacing: 0.05em;
//   color: #94a3b8;
//   font-weight: 600;
// }
// .hbh-stat-value {
//   font-size: 20px;
//   font-weight: 700;
// }
// .hbh-stat-value.total { color: #2563eb; }
// .hbh-stat-value.booked { color: #16a34a; }
// .hbh-stat-value.pending { color: #d97706; }
// .hbh-card {
//   background: #ffffff;
//   border-radius: 14px;
//   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
//   margin-bottom: 20px;
// }
// .hbh-filter-card {
//   padding: 22px 26px;
// }
// .hbh-filter-title {
//   font-size: 11px;
//   letter-spacing: 0.05em;
//   color: #94a3b8;
//   font-weight: 700;
//   margin-bottom: 16px;
// }
// .hbh-filter-row {
//   display: flex;
//   align-items: flex-end;
//   gap: 16px;
//   flex-wrap: wrap;
// }
// .hbh-field {
//   display: flex;
//   flex-direction: column;
//   gap: 6px;
// }
// .hbh-field label {
//   font-size: 13px;
//   font-weight: 600;
//   color: #334155;
// }
// .hbh-field input,
// .hbh-field select {
//   border: 1px solid #e2e8f0;
//   border-radius: 8px;
//   padding: 9px 12px;
//   font-size: 13px;
//   color: #1e293b;
//   outline: none;
//   min-width: 150px;
//   background: #fff;
// }
// .hbh-field input:focus,
// .hbh-field select:focus {
//   border-color: #2563eb;
//   box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
// }
// .hbh-field input::placeholder {
//   color: #b8c2d1;
// }
// .hbh-actions {
//   display: flex;
//   gap: 10px;
//   margin-left: auto;
// }
// .hbh-btn {
//   border: none;
//   border-radius: 8px;
//   padding: 9px 16px;
//   font-size: 13px;
//   font-weight: 600;
//   cursor: pointer;
//   display: inline-flex;
//   align-items: center;
//   gap: 6px;
//   white-space: nowrap;
// }
// .hbh-btn:disabled {
//   opacity: 0.6;
//   cursor: not-allowed;
// }
// .hbh-btn-primary {
//   background: #2563eb;
//   color: #fff;
// }
// .hbh-btn-primary:hover:not(:disabled) {
//   background: #1d4ed8;
// }
// .hbh-btn-outline {
//   background: #fff;
//   border: 1px solid #e2e8f0;
//   color: #475569;
// }
// .hbh-btn-outline:hover:not(:disabled) {
//   background: #f8fafc;
// }
// .hbh-table-card {
//   overflow: hidden;
// }
// .hbh-table-header {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 16px 26px;
// }
// .hbh-table-count {
//   font-size: 13px;
//   color: #334155;
// }
// .hbh-table-count b {
//   font-weight: 700;
// }
// .hbh-table-hint {
//   font-size: 12px;
//   color: #b8c2d1;
// }
// .hbh-table-wrap {
//   overflow-x: auto;
// }
// .hbh-table {
//   width: 100%;
//   border-collapse: collapse;
//   font-size: 13px;
// }
// .hbh-table thead tr {
//   border-top: 1px solid #f1f5f9;
//   border-bottom: 1px solid #f1f5f9;
//   text-align: left;
// }
// .hbh-table th {
//   padding: 12px 20px;
//   font-size: 11px;
//   letter-spacing: 0.04em;
//   color: #94a3b8;
//   font-weight: 600;
//   white-space: nowrap;
// }
// .hbh-table td {
//   padding: 14px 20px;
//   border-bottom: 1px solid #f8fafc;
//   color: #334155;
//   white-space: nowrap;
// }
// .hbh-table tbody tr:hover {
//   background: #f8fafc;
// }
// .hbh-idx {
//   color: #94a3b8;
// }
// .hbh-hotel-name {
//   font-weight: 600;
//   color: #1e293b;
// }
// .hbh-booking-link {
//   color: #2563eb;
//   font-weight: 600;
// }
// .hbh-badge {
//   display: inline-block;
//   padding: 4px 12px;
//   border-radius: 999px;
//   font-size: 12px;
//   font-weight: 600;
// }
// .hbh-badge-booked {
//   background: #d1fae5;
//   color: #047857;
// }
// .hbh-badge-pending {
//   background: #fef3c7;
//   color: #b45309;
// }
// .hbh-badge-cancelled {
//   background: #fee2e2;
//   color: #b91c1c;
// }
// .hbh-row-btn {
//   border-radius: 6px;
//   padding: 6px 14px;
//   font-size: 12px;
//   font-weight: 600;
//   cursor: pointer;
//   border: 1px solid transparent;
// }
// .hbh-btn-ticket {
//   background: #f1f5f9;
//   color: #334155;
// }
// .hbh-btn-ticket:hover {
//   background: #e2e8f0;
// }
// .hbh-btn-edit {
//   background: #dbeafe;
//   color: #1d4ed8;
//   margin-left: 6px;
// }
// .hbh-btn-edit:hover {
//   background: #bfdbfe;
// }
// .hbh-empty {
//   text-align: center;
//   padding: 40px;
//   color: #94a3b8;
// }
// .hbh-modal-overlay {
//   position: fixed;
//   inset: 0;
//   background: rgba(15, 23, 42, 0.45);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   z-index: 999;
//   padding: 16px;
// }
// .hbh-modal {
//   background: #fff;
//   border-radius: 14px;
//   width: 100%;
//   max-width: 640px;
//   max-height: 90vh;
//   overflow-y: auto;
//   box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
// }
// .hbh-modal-header {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 18px 24px;
//   border-bottom: 1px solid #f1f5f9;
// }
// .hbh-modal-header h2 {
//   font-size: 16px;
//   margin: 0;
//   color: #1e293b;
// }
// .hbh-modal-close {
//   border: none;
//   background: none;
//   font-size: 22px;
//   line-height: 1;
//   color: #94a3b8;
//   cursor: pointer;
// }
// .hbh-modal-close:hover {
//   color: #475569;
// }
// .hbh-modal-body {
//   padding: 22px 24px;
// }
// .hbh-modal-loading,
// .hbh-modal-error {
//   text-align: center;
//   padding: 40px 0;
//   color: #94a3b8;
// }
// .hbh-modal-error {
//   color: #dc2626;
// }
// .hbh-modal-section {
//   border-top: 1px solid #f1f5f9;
//   padding-top: 16px;
//   margin-top: 16px;
// }
// .hbh-modal-section:first-child {
//   border-top: none;
//   padding-top: 0;
//   margin-top: 0;
// }
// .hbh-modal-label {
//   font-size: 11px;
//   color: #94a3b8;
//   margin-bottom: 4px;
// }
// .hbh-modal-value {
//   font-weight: 600;
//   color: #1e293b;
//   font-size: 14px;
// }
// .hbh-modal-sub {
//   font-size: 13px;
//   color: #64748b;
//   margin-top: 2px;
// }
// .hbh-modal-top-row {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
// }
// .hbh-modal-grid {
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 14px;
// }
// .hbh-modal-price-row {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
// }
// .hbh-modal-price {
//   font-size: 20px;
//   font-weight: 700;
//   color: #2563eb;
// }
// .hbh-page-loading {
//   text-align: center;
//   padding: 60px 20px;
//   color: #64748b;
//   font-size: 14px;
// }
// /* ==== Edit modal form (redesigned) ==== */
// .hbh-edit-modal {
//   max-width: 560px;
// }
// .hbh-edit-header {
//   padding: 20px 24px;
//   border-bottom: 1px solid #f1f5f9;
//   background: linear-gradient(135deg, #eef2ff 0%, #eff6ff 100%);
//   border-radius: 14px 14px 0 0;
//   display: flex;
//   align-items: flex-start;
//   justify-content: space-between;
// }
// .hbh-edit-header-left {
//   display: flex;
//   gap: 12px;
//   align-items: flex-start;
// }
// .hbh-edit-header-icon {
//   width: 40px;
//   height: 40px;
//   border-radius: 10px;
//   background: #2563eb;
//   color: #fff;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 18px;
//   flex-shrink: 0;
// }
// .hbh-edit-header h2 {
//   font-size: 16px;
//   margin: 0;
//   color: #0f172a;
// }
// .hbh-edit-header-sub {
//   font-size: 12px;
//   color: #64748b;
//   margin-top: 3px;
// }
// .hbh-edit-header-sub b {
//   color: #334155;
// }
// .hbh-edit-body {
//   padding: 22px 24px 24px;
// }
// .hbh-edit-section-title {
//   font-size: 11px;
//   letter-spacing: 0.06em;
//   color: #94a3b8;
//   font-weight: 700;
//   margin: 0 0 12px;
//   text-transform: uppercase;
// }
// .hbh-edit-section-title:not(:first-child) {
//   margin-top: 22px;
// }
// .hbh-edit-form {
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 14px 16px;
// }
// .hbh-edit-field {
//   display: flex;
//   flex-direction: column;
//   gap: 6px;
// }
// .hbh-edit-field.full {
//   grid-column: 1 / -1;
// }
// .hbh-edit-field label {
//   font-size: 12px;
//   font-weight: 600;
//   color: #334155;
//   display: flex;
//   align-items: center;
//   gap: 5px;
// }
// .hbh-edit-field input,
// .hbh-edit-field select {
//   border: 1.5px solid #e2e8f0;
//   border-radius: 9px;
//   padding: 10px 12px;
//   font-size: 13px;
//   color: #1e293b;
//   outline: none;
//   background: #fbfcfe;
//   transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
// }
// .hbh-edit-field input:hover,
// .hbh-edit-field select:hover {
//   border-color: #cbd5e1;
// }
// .hbh-edit-field input:focus,
// .hbh-edit-field select:focus {
//   border-color: #2563eb;
//   box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
//   background: #fff;
// }
// .hbh-edit-field input:disabled,
// .hbh-edit-field select:disabled {
//   background: #f1f5f9;
//   color: #94a3b8;
//   cursor: not-allowed;
// }
// .hbh-edit-amount-wrap {
//   position: relative;
// }
// .hbh-edit-amount-wrap span {
//   position: absolute;
//   left: 12px;
//   top: 50%;
//   transform: translateY(-50%);
//   font-size: 13px;
//   color: #94a3b8;
//   font-weight: 600;
// }
// .hbh-edit-amount-wrap input {
//   padding-left: 26px;
// }
// .hbh-status-pills {
//   display: flex;
//   gap: 8px;
//   grid-column: 1 / -1;
// }
// .hbh-status-pill {
//   flex: 1;
//   border: 1.5px solid #e2e8f0;
//   background: #fff;
//   border-radius: 9px;
//   padding: 9px 10px;
//   font-size: 12.5px;
//   font-weight: 600;
//   color: #64748b;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 6px;
//   transition: all 0.15s;
// }
// .hbh-status-pill:hover:not(:disabled) {
//   border-color: #cbd5e1;
// }
// .hbh-status-pill .dot {
//   width: 7px;
//   height: 7px;
//   border-radius: 50%;
//   background: #cbd5e1;
// }
// .hbh-status-pill.active-confirmed {
//   border-color: #16a34a;
//   background: #f0fdf4;
//   color: #047857;
// }
// .hbh-status-pill.active-confirmed .dot { background: #16a34a; }
// .hbh-status-pill.active-pending {
//   border-color: #d97706;
//   background: #fffbeb;
//   color: #b45309;
// }
// .hbh-status-pill.active-pending .dot { background: #d97706; }
// .hbh-status-pill.active-cancelled {
//   border-color: #dc2626;
//   background: #fef2f2;
//   color: #b91c1c;
// }
// .hbh-status-pill.active-cancelled .dot { background: #dc2626; }
// .hbh-status-pill:disabled {
//   cursor: not-allowed;
//   opacity: 0.7;
// }
// .hbh-edit-footer {
//   grid-column: 1 / -1;
//   display: flex;
//   justify-content: flex-end;
//   gap: 10px;
//   margin-top: 8px;
//   padding-top: 18px;
//   border-top: 1px solid #f1f5f9;
// }
// .hbh-edit-msg {
//   grid-column: 1 / -1;
//   font-size: 13px;
//   font-weight: 500;
//   padding: 10px 14px;
//   border-radius: 9px;
//   display: flex;
//   align-items: center;
//   gap: 8px;
// }
// .hbh-edit-msg.success {
//   background: #d1fae5;
//   color: #047857;
// }
// .hbh-edit-msg.error {
//   background: #fee2e2;
//   color: #b91c1c;
// }
// /* ==== Voucher-style ticket modal ==== */
// .hbh-voucher {
//   background: #fff;
// }
// .hbh-voucher-topbar {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 16px 24px;
//   border-bottom: 1px solid #f1f5f9;
// }
// .hbh-voucher-brand {
//   font-size: 18px;
//   font-weight: 800;
//   color: #1e293b;
//   letter-spacing: 0.02em;
// }
// .hbh-voucher-brand span {
//   color: #2563eb;
// }
// .hbh-voucher-qr {
//   width: 56px;
//   height: 56px;
//   border: 1px solid #e2e8f0;
//   border-radius: 6px;
// }
// .hbh-voucher-pnr-row {
//   padding: 14px 24px 0;
// }
// .hbh-voucher-pnr {
//   font-size: 13px;
//   font-weight: 700;
//   color: #1e293b;
// }
// .hbh-voucher-status {
//   font-size: 13px;
//   font-weight: 700;
//   margin-top: 4px;
// }
// .hbh-voucher-status.confirmed { color: #16a34a; }
// .hbh-voucher-status.pending { color: #d97706; }
// .hbh-voucher-status.cancelled { color: #dc2626; }
// .hbh-voucher-box {
//   margin: 16px 24px 24px;
//   border: 1px solid #e2e8f0;
//   border-radius: 10px;
//   overflow: hidden;
// }
// .hbh-voucher-box-head {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   background: #f8fafc;
//   padding: 10px 16px;
//   border-bottom: 1px solid #e2e8f0;
// }
// .hbh-voucher-box-head-title {
//   font-size: 13px;
//   font-weight: 700;
//   color: #94a3b8;
// }
// .hbh-voucher-box-head-date {
//   font-size: 12px;
//   color: #94a3b8;
// }
// .hbh-voucher-body {
//   display: flex;
//   gap: 16px;
//   padding: 16px;
// }
// .hbh-voucher-details {
//   flex: 1;
//   display: grid;
//   grid-template-columns: 1fr;
//   gap: 10px;
// }
// .hbh-voucher-row {
//   display: flex;
//   gap: 8px;
//   font-size: 13px;
// }
// .hbh-voucher-row-label {
//   min-width: 130px;
//   font-weight: 700;
//   color: #1e293b;
// }
// .hbh-voucher-row-value {
//   color: #334155;
// }
// .hbh-voucher-booked-by {
//   width: 150px;
//   border: 1px solid #e2e8f0;
//   border-radius: 8px;
//   padding: 10px;
//   text-align: center;
//   font-size: 11px;
//   color: #64748b;
//   height: fit-content;
// }
// .hbh-voucher-booked-by b {
//   display: block;
//   font-size: 11px;
//   color: #1e293b;
//   margin-bottom: 6px;
// }
// .hbh-voucher-booked-by .txn {
//   margin-top: 8px;
//   font-weight: 700;
//   color: #2563eb;
//   font-size: 12px;
//   word-break: break-all;
// }
// .hbh-voucher-table-wrap {
//   padding: 0 16px 16px;
// }
// .hbh-voucher-table {
//   width: 100%;
//   border-collapse: collapse;
//   font-size: 12px;
// }
// .hbh-voucher-table th {
//   background: #f8fafc;
//   text-align: left;
//   padding: 8px 10px;
//   border: 1px solid #e2e8f0;
//   color: #475569;
//   font-weight: 700;
// }
// .hbh-voucher-table td {
//   padding: 8px 10px;
//   border: 1px solid #e2e8f0;
//   color: #334155;
// }
// .hbh-voucher-footer {
//   border-top: 1px solid #f1f5f9;
//   padding: 20px 24px;
//   display: grid;
//   grid-template-columns: repeat(4, 1fr);
//   gap: 16px;
// }
// .hbh-voucher-footer-col h4 {
//   font-size: 12px;
//   color: #1e293b;
//   margin: 0 0 8px;
// }
// .hbh-voucher-footer-col a,
// .hbh-voucher-footer-col p {
//   display: block;
//   font-size: 11px;
//   color: #64748b;
//   margin-bottom: 6px;
//   text-decoration: none;
// }
// .hbh-voucher-social {
//   display: flex;
//   gap: 8px;
// }
// .hbh-voucher-social span {
//   width: 22px;
//   height: 22px;
//   border-radius: 50%;
//   background: #1e293b;
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   color: #fff;
//   font-size: 11px;
// }
// .hbh-voucher-copyright {
//   border-top: 1px solid #f1f5f9;
//   padding: 12px 24px;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   font-size: 11px;
//   color: #94a3b8;
// }
// @media (max-width: 640px) {
//   .hbh-page {
//     padding-left: 24px;
//   }
//   .hbh-actions {
//     margin-left: 0;
//     width: 100%;
//   }
//   .hbh-stats {
//     width: 100%;
//     justify-content: space-between;
//   }
//   .hbh-voucher-body {
//     flex-direction: column;
//   }
//   .hbh-voucher-booked-by {
//     width: 100%;
//   }
//   .hbh-voucher-footer {
//     grid-template-columns: 1fr 1fr;
//   }
//   .hbh-edit-form {
//     grid-template-columns: 1fr;
//   }
// }
//   .hbh-logo {
//   height: 70px;
//   width: auto;
//   display: block;
//   object-fit: contain;
// }

// .hbh-voucher-brand {
//   display: flex;
//   align-items: center;
// }
// `;

// async function fetchBookingList({ fromDate, toDate, bookingId, pnr, transactionId }) {
//   try {
//     const res = await fetch(GET_BOOKING_LIST_API, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         fromDate: fromDate || null,
//         toDate: toDate || null,
//         bookingId: bookingId || null,
//         pnr: pnr || null,
//         transactionId: transactionId || null,
//       }),
//     });
//     if (!res.ok) return [];
//     const data = await res.json();

//     const list = Array.isArray(data)
//       ? data
//       : data?.Data || data?.data || data?.BookingList || data?.List || data?.Result || [];

//     return list;
//   } catch (err) {
//     return [];
//   }
// }

// async function fetchTicketById(transactionId) {
//   try {
//     const res = await fetch(
//       `${GET_OFFLINE_TICKET_API}?transactionId=${transactionId}`
//     );
//     if (!res.ok) return null;
//     const data = await res.json();
//     if (!data || !data.HotelName) return null;
//     return { ...data, TransactionId: data.TransactionId || transactionId };
//   } catch (err) {
//     return null;
//   }
// }


// async function updateAdminBooking(payload) {
//   console.log("[UpdateAdminBooking] sending payload:", payload);
//   try {
//     const res = await fetch(UPDATE_BOOKING_API, {
//       method: UPDATE_BOOKING_METHOD,
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     console.log("[UpdateAdminBooking] HTTP status:", res.status, res.statusText);

   
//     const rawText = await res.text();
//     console.log("[UpdateAdminBooking] raw response body:", rawText);

//     let data = null;
//     try {
//       data = rawText ? JSON.parse(rawText) : null;
//     } catch (parseErr) {
//       console.error("[UpdateAdminBooking] response JSON parse failed:", parseErr);
//       return {
//         IsSuccess: false,
//         Message: `Server se response samajh nahi aaya (status ${res.status}). Console check karo.`,
//       };
//     }

//     if (!res.ok) {
//       return {
//         IsSuccess: false,
//         Message: (data && data.Message) || `Update fail (HTTP ${res.status}).`,
//       };
//     }

//     if (!data) {
//       return { IsSuccess: false, Message: "Server se khaali response aaya." };
//     }

//     return data; 
//   } catch (err) {
    
//     console.error("[UpdateAdminBooking] fetch threw an error (likely CORS/network):", err);
//     return {
//       IsSuccess: false,
//       Message: "Network/CORS error. Console (F12) mein exact error dekho.",
//     };
//   }
// }

// export default function HotelBookingHistory() {
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [bookingIdFilter, setBookingIdFilter] = useState("");
//   const [status, setStatus] = useState("All Status");

//   const [bookings, setBookings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [loadError, setLoadError] = useState("");

//   const [ticketModalOpen, setTicketModalOpen] = useState(false);
//   const [ticketLoading, setTicketLoading] = useState(false);
//   const [ticketError, setTicketError] = useState("");
//   const [ticketData, setTicketData] = useState(null);

//   // ==== EDIT MODAL STATE ====
//   const [editModalOpen, setEditModalOpen] = useState(false);
//   const [editSaving, setEditSaving] = useState(false);
//   const [editMsg, setEditMsg] = useState({ type: "", text: "" }); 
//   const [editForm, setEditForm] = useState({
//     transactionId: null,
//     pnr: "",
//     customerName: "",
//     checkInDate: "",
//     checkOutDate: "",
//     amount: "",
//     bookingStatus: 4,
//     hotelName: "",  
//     bookingId: "",    
//   });

  
//   const loadBookings = useCallback(async (filters) => {
//     setLoading(true);
//     setLoadError("");
//     try {
//       const list = await fetchBookingList(filters);
//       setBookings(list);
//       if (list.length === 0) {
//         setLoadError("Koi booking nahi mili.");
//       }
//     } catch (err) {
//       setLoadError("Bookings load nahi ho paayi. Dobara try karo.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     const { from, to } = getDefaultDateRange();
//     setFromDate(from);
//     setToDate(to);
//     loadBookings({ fromDate: from, toDate: to, bookingId: null, pnr: null, transactionId: null });
//   }, [loadBookings]);

//   const filteredBookings = bookings.filter((b) => {
//     const matchesStatus =
//       status === "All Status" ? true : getListStatusLabel(b.BookingStatus) === status;
//     return matchesStatus;
//   });

//   const totalCount = filteredBookings.length;
//   const bookedCount = filteredBookings.filter(
//     (b) => getListStatusLabel(b.BookingStatus) === "Confirmed"
//   ).length;
//   const pendingCount = filteredBookings.filter(
//     (b) => getListStatusLabel(b.BookingStatus) === "Pending"
//   ).length;

//   const handleSearch = () => {
//     loadBookings({
//       fromDate: fromDate || null,
//       toDate: toDate || null,
//       bookingId: bookingIdFilter.trim() || null,
//       pnr: null,
//       transactionId: null,
//     });
//   };

//   const handleReset = () => {
//     const { from, to } = getDefaultDateRange();
//     setFromDate(from);
//     setToDate(to);
//     setBookingIdFilter("");
//     setStatus("All Status");
//     loadBookings({ fromDate: from, toDate: to, bookingId: null, pnr: null, transactionId: null });
//   };

//   const handleViewTicket = async (transactionId) => {
//     setTicketModalOpen(true);
//     setTicketLoading(true);
//     setTicketError("");
//     setTicketData(null);

//     const data = await fetchTicketById(transactionId);
//     if (data) {
//       setTicketData(data);
//     } else {
//       setTicketError("Ticket load nahi ho paayi. Dobara try karo.");
//     }
//     setTicketLoading(false);
//   };

//   const closeModal = () => {
//     setTicketModalOpen(false);
//     setTicketData(null);
//     setTicketError("");
//   };

//   const handleEditClick = (b) => {
//     setEditMsg({ type: "", text: "" });
//     setEditForm({
//       transactionId: b.TransactionId,
//       pnr: b.PNR || "",
//       customerName: b.CustomerName || "",
//       checkInDate: toInputDate(b.CheckInDate),
//       checkOutDate: toInputDate(b.CheckOutDate),
//       amount: b.Amount ?? "",
//       bookingStatus: b.BookingStatus ?? 4,
//       hotelName: b.HotelName || "",
//       bookingId: b.BookingId || "",
//     });
//     setEditModalOpen(true);
//   };

//   const closeEditModal = () => {
//     if (editSaving) return;
//     setEditModalOpen(false);
//     setEditMsg({ type: "", text: "" });
//   };

//   const handleEditFieldChange = (field, value) => {
//     setEditForm((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleEditSubmit = async () => {
//     setEditSaving(true);
//     setEditMsg({ type: "", text: "" });

//     const payload = {
//       transactionId: editForm.transactionId,
//       pnr: editForm.pnr.trim(),
//       customerName: editForm.customerName.trim(),
//       checkInDate: editForm.checkInDate,
//       checkOutDate: editForm.checkOutDate,
//       amount: Number(editForm.amount) || 0,
//       bookingStatus: Number(editForm.bookingStatus),
//     };

//     const res = await updateAdminBooking(payload);

//     if (res.IsSuccess) {
//       setEditMsg({ type: "success", text: res.Message || "Booking updated successfully." });

    
//       setBookings((prev) =>
//         prev.map((b) =>
//           b.TransactionId === editForm.transactionId
//             ? {
//                 ...b,
//                 PNR: payload.pnr,
//                 CustomerName: payload.customerName,
//                 CheckInDate: payload.checkInDate,
//                 CheckOutDate: payload.checkOutDate,
//                 Amount: payload.amount,
//                 BookingStatus: payload.bookingStatus,
//               }
//             : b
//         )
//       );

     
//       setTimeout(() => {
//         setEditModalOpen(false);
//         setEditMsg({ type: "", text: "" });
//       }, 1000);
//     } else {
//       setEditMsg({ type: "error", text: res.Message || "Update fail ho gaya." });
//     }

//     setEditSaving(false);
//   };

//   // ==== EXPORT EXCEL (CSV) — from real fetched data only ====
//   const handleExportExcel = () => {
//     const headers = [
//       "#",
//       "Hotel Name",
//       "Booking ID",
//       "Passenger",
//       "Checkin",
//       "Checkout",
//       "Status",
//     ];
//     const rows = filteredBookings.map((b, idx) => [
//       idx + 1,
//       b.HotelName,
//       b.BookingId,
//       b.CustomerName,
//       formatDate(b.CheckInDate),
//       formatDate(b.CheckOutDate),
//       getListStatusLabel(b.BookingStatus),
//     ]);

//     const csvContent =
//       headers.join(",") +
//       "\n" +
//       rows.map((r) => r.map((cell) => `"${cell ?? ""}"`).join(",")).join("\n");

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = "hotel_booking_history.csv";
//     link.click();
//   };

//   return (
//     <div className="hbh-page">
//       <Sidebar/>
//       <style>{HBH_STYLES}</style>

//       {/* Header */}
//       <div className="hbh-header">
//         <div>
//           <h1>Hotel Bookings</h1>
//           <p>Real-time overview of all hotel reservations</p>
//         </div>
//         <div className="hbh-stats">
//           <div className="hbh-stat-card">
//             <div className="hbh-stat-label">TOTAL</div>
//             <div className="hbh-stat-value total">{totalCount}</div>
//           </div>
//           <div className="hbh-stat-card">
//             <div className="hbh-stat-label">BOOKED</div>
//             <div className="hbh-stat-value booked">{bookedCount}</div>
//           </div>
//           <div className="hbh-stat-card">
//             <div className="hbh-stat-label">PENDING</div>
//             <div className="hbh-stat-value pending">{pendingCount}</div>
//           </div>
//         </div>
//       </div>

//       {/* Search & Filter */}
//       <div className="hbh-card hbh-filter-card">
//         <div className="hbh-filter-title">SEARCH &amp; FILTER</div>
//         <div className="hbh-filter-row">
//           <div className="hbh-field">
//             <label>From Date</label>
//             <input
//               type="date"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//             />
//           </div>
//           <div className="hbh-field">
//             <label>To Date</label>
//             <input
//               type="date"
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)}
//             />
//           </div>
//           <div className="hbh-field">
//             <label>Booking ID</label>
//             <input
//               type="text"
//               placeholder="e.g. TJ2088182184089"
//               value={bookingIdFilter}
//               onChange={(e) => setBookingIdFilter(e.target.value)}
//             />
//           </div>
//           <div className="hbh-field">
//             <label>Status</label>
//             <select value={status} onChange={(e) => setStatus(e.target.value)}>
//               <option>All Status</option>
//               <option>Confirmed</option>
//               <option>Pending</option>
//               <option>Cancelled</option>
//             </select>
//           </div>

//           <div className="hbh-actions">
//             <button
//               className="hbh-btn hbh-btn-primary"
//               onClick={handleExportExcel}
//               disabled={loading || filteredBookings.length === 0}
//             >
//               📊 Export Excel
//             </button>
//             <button
//               className="hbh-btn hbh-btn-primary"
//               onClick={handleSearch}
//               disabled={loading}
//             >
//               🔍 {loading ? "Searching..." : "Search"}
//             </button>
           
//           </div>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="hbh-card hbh-table-card">
//         <div className="hbh-table-header">
//           <div className="hbh-table-count">
//             <b>{filteredBookings.length}</b> bookings found
//           </div>
//           <div className="hbh-table-hint">
//             Scroll horizontally on smaller screens
//           </div>
//         </div>

//         {loading ? (
//           <div className="hbh-page-loading">Loading bookings from API...</div>
//         ) : loadError && filteredBookings.length === 0 ? (
//           <div className="hbh-page-loading">{loadError}</div>
//         ) : (
//           <div className="hbh-table-wrap">
//             <table className="hbh-table">
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>HOTEL</th>
//                   <th>BOOKING ID</th>
//                   <th>PASSENGER</th>
//                   <th>CHECKIN</th>
//                   <th>CHECKOUT</th>
//                   <th>STATUS</th>
//                   <th>TICKET</th>
//                   <th>ACTION</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredBookings.map((b, idx) => (
//                   <tr key={b.TransactionId || b.BookingId || idx}>
//                     <td className="hbh-idx">{idx + 1}</td>
//                     <td className="hbh-hotel-name">{b.HotelName}</td>
//                     <td>
//                       <span className="hbh-booking-link">
//                         {b.BookingId}
//                       </span>
//                     </td>
//                     <td>{b.CustomerName}</td>
//                     <td>{formatDate(b.CheckInDate)}</td>
//                     <td>{formatDate(b.CheckOutDate)}</td>
//                     <td>
//                       <span
//                         className={
//                           badgeClass[getListStatusLabel(b.BookingStatus)] ||
//                           "hbh-badge hbh-badge-pending"
//                         }
//                       >
//                         {getListStatusLabel(b.BookingStatus)}
//                       </span>
//                     </td>
//                     <td>
//                       <button
//                         className="hbh-row-btn hbh-btn-ticket"
//                         onClick={() => handleViewTicket(b.TransactionId)}
//                       >
//                         Ticket
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         className="hbh-row-btn hbh-btn-edit"
//                         onClick={() => handleEditClick(b)}
//                       >
//                         ✏️ Edit
//                       </button>
//                     </td>
//                   </tr>
//                 ))}

//                 {filteredBookings.length === 0 && (
//                   <tr>
//                     <td colSpan={9} className="hbh-empty">
//                       Koi booking nahi mili.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>

//       {/* Edit Modal */}
//       {editModalOpen && (
//         <div className="hbh-modal-overlay" onClick={closeEditModal}>
//           <div className="hbh-modal hbh-edit-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="hbh-edit-header">
//               <div className="hbh-edit-header-left">
//                 <div className="hbh-edit-header-icon">✏️</div>
//                 <div>
//                   <h2>Edit Booking</h2>
//                   <div className="hbh-edit-header-sub">
//                     {editForm.hotelName && <><b>{editForm.hotelName}</b> · </>}
//                     {editForm.bookingId || "—"}
//                   </div>
//                 </div>
//               </div>
//               <button className="hbh-modal-close" onClick={closeEditModal}>
//                 &times;
//               </button>
//             </div>

//             <div className="hbh-edit-body">
//               <div className="hbh-edit-form">
//                 {editMsg.text && (
//                   <div className={`hbh-edit-msg ${editMsg.type}`}>
//                     {editMsg.type === "success" ? "✅" : "⚠️"} {editMsg.text}
//                   </div>
//                 )}

//                 <div className="hbh-edit-field full">
//                   <div className="hbh-edit-section-title">Guest &amp; Reference</div>
//                 </div>

//                 <div className="hbh-edit-field">
//                   <label>PNR</label>
//                   <input
//                     type="text"
//                     value={editForm.pnr}
//                     onChange={(e) => handleEditFieldChange("pnr", e.target.value)}
//                     disabled={editSaving}
//                   />
//                 </div>

//                 <div className="hbh-edit-field">
//                   <label>Customer Name</label>
//                   <input
//                     type="text"
//                     value={editForm.customerName}
//                     onChange={(e) => handleEditFieldChange("customerName", e.target.value)}
//                     disabled={editSaving}
//                   />
//                 </div>

//                 <div className="hbh-edit-field full">
//                   <div className="hbh-edit-section-title">Stay Details</div>
//                 </div>

//                 <div className="hbh-edit-field">
//                   <label>📅 Check In</label>
//                   <input
//                     type="date"
//                     value={editForm.checkInDate}
//                     onChange={(e) => handleEditFieldChange("checkInDate", e.target.value)}
//                     disabled={editSaving}
//                   />
//                 </div>

//                 <div className="hbh-edit-field">
//                   <label>📅 Check Out</label>
//                   <input
//                     type="date"
//                     value={editForm.checkOutDate}
//                     onChange={(e) => handleEditFieldChange("checkOutDate", e.target.value)}
//                     disabled={editSaving}
//                   />
//                 </div>

//                 <div className="hbh-edit-field">
//                   <label>Amount</label>
//                   <div className="hbh-edit-amount-wrap">
//                     <span>₹</span>
//                     <input
//                       type="number"
//                       value={editForm.amount}
//                       onChange={(e) => handleEditFieldChange("amount", e.target.value)}
//                       disabled={editSaving}
//                     />
//                   </div>
//                 </div>

//                 <div className="hbh-edit-field full">
//                   <div className="hbh-edit-section-title">Booking Status</div>
//                 </div>

//                 <div className="hbh-status-pills">
//                   {EDIT_STATUS_OPTIONS.map((opt) => {
//                     const isActive = Number(editForm.bookingStatus) === opt.value;
//                     const activeClass =
//                       opt.label === "Confirmed"
//                         ? "active-confirmed"
//                         : opt.label === "Pending"
//                         ? "active-pending"
//                         : "active-cancelled";
//                     return (
//                       <button
//                         type="button"
//                         key={opt.value}
//                         className={`hbh-status-pill ${isActive ? activeClass : ""}`}
//                         onClick={() => handleEditFieldChange("bookingStatus", opt.value)}
//                         disabled={editSaving}
//                       >
//                         <span className="dot" />
//                         {opt.label}
//                       </button>
//                     );
//                   })}
//                 </div>

//                 <div className="hbh-edit-footer">
//                   <button
//                     className="hbh-btn hbh-btn-outline"
//                     onClick={closeEditModal}
//                     disabled={editSaving}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     className="hbh-btn hbh-btn-primary"
//                     onClick={handleEditSubmit}
//                     disabled={editSaving}
//                   >
//                     {editSaving ? "Updating..." : "💾 Update Booking"}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {ticketModalOpen && (
//         <div className="hbh-modal-overlay" onClick={closeModal}>
//           <div className="hbh-modal hbh-voucher" onClick={(e) => e.stopPropagation()}>
//             <div className="hbh-modal-header">
//               <h2>Hotel Voucher</h2>
//               <button className="hbh-modal-close" onClick={closeModal}>
//                 &times;
//               </button>
//             </div>

//             {ticketLoading && (
//               <div className="hbh-modal-loading">Loading ticket...</div>
//             )}

//             {ticketError && (
//               <div className="hbh-modal-error">{ticketError}</div>
//             )}

//             {!ticketLoading && !ticketError && ticketData && (
//               <>
//              <div className="hbh-voucher-topbar">
//   <div className="hbh-voucher-brand">
//     <img
//       src="/tripji.png"
//       alt="TripJi Logo"
//       className="hbh-logo"
//     />
//   </div>

//   <div className="hbh-voucher-qr" />
// </div>
//                 <div className="hbh-voucher-pnr-row">
//                   <div className="hbh-voucher-pnr">
//                     Hotel PNR: {ticketData.TicketNumber}
//                   </div>
//                   <div
//                     className={
//                       "hbh-voucher-status " +
//                       (getTicketStatusLabel(ticketData.BookingStatus) === "Confirmed"
//                         ? "confirmed"
//                         : getTicketStatusLabel(ticketData.BookingStatus) === "Pending"
//                         ? "pending"
//                         : "cancelled")
//                     }
//                   >
//                     Status:{" "}
//                     {getTicketStatusLabel(ticketData.BookingStatus) === "Confirmed"
//                       ? "Booking Confirmed"
//                       : getTicketStatusLabel(ticketData.BookingStatus) === "Pending"
//                       ? "Booking Pending"
//                       : "Booking Cancelled"}
//                   </div>
//                 </div>

//                 {/* Main details box */}
//                 <div className="hbh-voucher-box">
//                   <div className="hbh-voucher-box-head">
//                     <div className="hbh-voucher-box-head-title">
//                       Hotel Ticket
//                     </div>
//                     <div className="hbh-voucher-box-head-date">
//                       Booking Date: {formatDate(ticketData.BookingDate)}
//                     </div>
//                   </div>

//                   <div className="hbh-voucher-body">
//                     <div className="hbh-voucher-details">
//                       <div className="hbh-voucher-row">
//                         <div className="hbh-voucher-row-label">
//                           DESTINATION:
//                         </div>
//                         <div className="hbh-voucher-row-value">
//                           {ticketData.CityName}, {ticketData.CountryName}
//                         </div>
//                       </div>
//                       <div className="hbh-voucher-row">
//                         <div className="hbh-voucher-row-label">
//                           HOTEL NAME:
//                         </div>
//                         <div className="hbh-voucher-row-value">
//                           {ticketData.HotelName}
//                         </div>
//                       </div>
//                       <div className="hbh-voucher-row">
//                         <div className="hbh-voucher-row-label">
//                           HOTEL ADDRESS:
//                         </div>
//                         <div className="hbh-voucher-row-value">
//                           {ticketData.HotelAddress}
//                         </div>
//                       </div>
//                       <div className="hbh-voucher-row">
//                         <div className="hbh-voucher-row-label">CHECK IN:</div>
//                         <div className="hbh-voucher-row-value">
//                           {formatDate(ticketData.CheckinDate)}
//                         </div>
//                       </div>
//                       <div className="hbh-voucher-row">
//                         <div className="hbh-voucher-row-label">
//                           CHECK OUT:
//                         </div>
//                         <div className="hbh-voucher-row-value">
//                           {formatDate(ticketData.CheckoutDate)}
//                         </div>
//                       </div>
//                       <div className="hbh-voucher-row">
//                         <div className="hbh-voucher-row-label">
//                           NO. OF ROOMS:
//                         </div>
//                         <div className="hbh-voucher-row-value">
//                           {ticketData.NumberOfRooms}
//                         </div>
//                       </div>
//                       <div className="hbh-voucher-row">
//                         <div className="hbh-voucher-row-label">ADULTS:</div>
//                         <div className="hbh-voucher-row-value">
//                           {ticketData.NumberOfAdults}
//                         </div>
//                       </div>
//                       <div className="hbh-voucher-row">
//                         <div className="hbh-voucher-row-label">
//                           CHILDREN:
//                         </div>
//                         <div className="hbh-voucher-row-value">
//                           {ticketData.NumberOfChild}
//                         </div>
//                       </div>
//                     </div>

//                     <div className="hbh-voucher-booked-by">
//                       <b>BOOKED BY:</b>
//                       TripCaliber
//                       <div className="txn">
//                         TXN ID: {ticketData.TicketNumber}
//                       </div>
//                     </div>
//                   </div>

//                   {/* Room table */}
//                   <div className="hbh-voucher-table-wrap">
//                     <table className="hbh-voucher-table">
//                       <thead>
//                         <tr>
//                           <th>Room No#</th>
//                           <th>Room Type/Board</th>
//                           <th>Guest Name</th>
//                           <th>Adults</th>
//                           <th>Children</th>
//                           <th>Room Rate</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td>ROOM 1</td>
//                           <td>{ticketData.RoomType || "-"}</td>
//                           <td>{ticketData.PassengerName}</td>
//                           <td>{ticketData.NumberOfAdults}</td>
//                           <td>{ticketData.NumberOfChild}</td>
//                           <td>
//                             {Number(ticketData.TotalPrice || 0).toLocaleString(
//                               "en-IN"
//                             )}
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>

//                 {/* Footer */}
//                 <div className="hbh-voucher-footer">
//                   <div className="hbh-voucher-footer-col">
//                     <h4>Company</h4>
//                     <a href="#">About Us</a>
//                     <a href="#">Blog</a>
//                     <a href="#">Privacy Policy</a>
//                     <a href="#">Terms of Use</a>
//                     <a href="#">Refund &amp; Cancellation Policy</a>
//                   </div>
//                   <div className="hbh-voucher-footer-col">
//                     <h4>Services</h4>
//                     <a href="#">Flight Booking</a>
//                     <a href="#">Hotel Booking</a>
//                   </div>
//                   <div className="hbh-voucher-footer-col">
//                     <h4>Help And Support</h4>
//                     <a href="#">Contact Us</a>
//                     <a href="#">Agent Login</a>
//                   </div>
//                   <div className="hbh-voucher-footer-col">
//                     <h4>Keep In Touch</h4>
//                     <div className="hbh-voucher-social">
//                       <span>f</span>
//                       <span>x</span>
//                       <span>in</span>
//                       <span>yt</span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="hbh-voucher-copyright">
//                   <span>© 2025 - 2026 TripCaliber</span>
//                   <span>Powered By: Naman Technolab</span>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       )}
//       <Footer2/>
//     </div>
//   );
// }
import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "./Sidebar";
import Footer2 from './Footer2';
// ==== CONFIG ====
const GET_OFFLINE_TICKET_API = process.env.REACT_APP_HOTEL_TICKET_API; // for single ticket (voucher modal)
const GET_BOOKING_LIST_API = process.env.REACT_APP_HOTEL_BOOKING_LIST_API; // for the table list (GetAdminBookingList)
const UPDATE_BOOKING_API = "https://api.hotel.namantechnolab.com/api/Static/UpdateAdminBooking"; // for edit/update
// If you get a 405 (Method Not Allowed), it means the backend hasn't allowed this method on this route.
// Check the "Allow" header in the Response Headers of this request in the Network tab, and put that method here.
// You can also confirm with the senior/backend team whether this action is [HttpPost] or [HttpPut]/[HttpGet].
const UPDATE_BOOKING_METHOD = "PUT"; // "POST" was failing (405), so trying PUT — change it back if needed

// ==== STATUS MAP for GetAdminBookingList's BookingStatus ====
// NOTE: This list API's status enum is DIFFERENT from the ticket API's (sample response had
// 1/4/6, while the ticket API had 0/1). If the mapping looks wrong, just change these values
// and everything else will update automatically.
const LIST_STATUS_MAP = {
  1: "Confirmed",
  4: "Pending",
  6: "Cancelled",
};
const getListStatusLabel = (bookingStatus) =>
  LIST_STATUS_MAP[bookingStatus] || "Pending";

// For the edit form's status dropdown (mirrors LIST_STATUS_MAP)
const EDIT_STATUS_OPTIONS = [
  { value: 1, label: "Confirmed" },
  { value: 4, label: "Pending" },
  { value: 6, label: "Cancelled" },
];

// The ticket (voucher) API has its own status enum — kept as-is, same as this component's older version
const getTicketStatusLabel = (bookingStatus) => {
  if (bookingStatus === 1) return "Confirmed";
  if (bookingStatus === 0) return "Pending";
  return "Cancelled";
};

const badgeClass = {
  Confirmed: "hbh-badge hbh-badge-booked",
  Pending: "hbh-badge hbh-badge-pending",
  Cancelled: "hbh-badge hbh-badge-cancelled",
};

const formatDate = (isoStr) => {
  if (!isoStr || isoStr.startsWith("0001")) return "-";
  const d = new Date(isoStr);
  if (isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// Builds a yyyy-mm-dd string from LOCAL date parts (toISOString() converts to UTC first,
// which can roll the date back/forward by a day in timezones like IST — this helper avoids
// that bug, so always use this instead of toISOString().split("T")[0])
const toLocalYMD = (d) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

// Converts a date to yyyy-mm-dd format for <input type="date">
const toInputDate = (isoStr) => {
  if (!isoStr || isoStr.startsWith("0001")) return "";
  const d = new Date(isoStr);
  if (isNaN(d.getTime())) return "";
  return toLocalYMD(d);
};

// Default date range for the first page load (last 30 days)
const getDefaultDateRange = () => {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 30);
  return { from: toLocalYMD(from), to: toLocalYMD(to) };
};

// Formats a yyyy-mm-dd (input value) into a nicer dd MMM yyyy for display
const formatInputDate = (yyyyMmDd) => {
  if (!yyyyMmDd) return "-";
  const d = new Date(yyyyMmDd);
  if (isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// ==== CSS (inline, within this same file) ====
const HBH_STYLES = `
.hbh-page {
  min-height: 100vh;
  background: #f3f5f9;
  /* The Sidebar is fixed-positioned (~190px wide), so we give this much left padding
     so the content doesn't get hidden behind it.
     If the Sidebar collapses/expands, adjust this value here. */
  padding: 24px 24px 24px 214px;
  font-family: "Segoe UI", Roboto, Arial, sans-serif;
  color: #1e293b;
  box-sizing: border-box;
}
.hbh-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #eef1f6;
  border-radius: 14px;
  padding: 22px 26px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;
}
.hbh-header h1 {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  color: #0f172a;
}
.hbh-header p {
  font-size: 13px;
  color: #64748b;
  margin: 4px 0 0;
}
.hbh-stats {
  display: flex;
  gap: 12px;
}
.hbh-stat-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 8px 20px;
  text-align: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  min-width: 80px;
}
.hbh-stat-label {
  font-size: 11px;
  letter-spacing: 0.05em;
  color: #94a3b8;
  font-weight: 600;
}
.hbh-stat-value {
  font-size: 20px;
  font-weight: 700;
}
.hbh-stat-value.total { color: #2563eb; }
.hbh-stat-value.booked { color: #16a34a; }
.hbh-stat-value.pending { color: #d97706; }
.hbh-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
}
.hbh-filter-card {
  padding: 22px 26px;
}
.hbh-filter-title {
  font-size: 11px;
  letter-spacing: 0.05em;
  color: #94a3b8;
  font-weight: 700;
  margin-bottom: 16px;
}
.hbh-filter-row {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
}
.hbh-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.hbh-field label {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}
.hbh-field input,
.hbh-field select {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 13px;
  color: #1e293b;
  outline: none;
  min-width: 150px;
  background: #fff;
}
.hbh-field input:focus,
.hbh-field select:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}
.hbh-field input::placeholder {
  color: #b8c2d1;
}
.hbh-actions {
  display: flex;
  gap: 10px;
  margin-left: auto;
}
.hbh-btn {
  border: none;
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.hbh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.hbh-btn-primary {
  background: #2563eb;
  color: #fff;
}
.hbh-btn-primary:hover:not(:disabled) {
  background: #1d4ed8;
}
.hbh-btn-outline {
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #475569;
}
.hbh-btn-outline:hover:not(:disabled) {
  background: #f8fafc;
}
.hbh-table-card {
  overflow: hidden;
}
.hbh-table-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 26px;
  gap: 16px;
  flex-wrap: wrap;
}
.hbh-table-count {
  font-size: 13px;
  color: #334155;
}
.hbh-table-count b {
  font-weight: 700;
}
.hbh-table-hint {
  font-size: 12px;
  color: #b8c2d1;
}
.hbh-table-wrap {
  overflow-x: auto;
}
.hbh-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.hbh-table thead tr {
  border-top: 1px solid #f1f5f9;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}
.hbh-table th {
  padding: 12px 20px;
  font-size: 11px;
  letter-spacing: 0.04em;
  color: #94a3b8;
  font-weight: 600;
  white-space: nowrap;
}
.hbh-table td {
  padding: 14px 20px;
  border-bottom: 1px solid #f8fafc;
  color: #334155;
  white-space: nowrap;
}
.hbh-table tbody tr:hover {
  background: #f8fafc;
}
.hbh-idx {
  color: #94a3b8;
}
.hbh-hotel-name {
  font-weight: 600;
  color: #1e293b;
}
.hbh-booking-link {
  color: #2563eb;
  font-weight: 600;
}
.hbh-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}
.hbh-badge-booked {
  background: #d1fae5;
  color: #047857;
}
.hbh-badge-pending {
  background: #fef3c7;
  color: #b45309;
}
.hbh-badge-cancelled {
  background: #fee2e2;
  color: #b91c1c;
}
.hbh-row-btn {
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
}
.hbh-btn-ticket {
  background: #f1f5f9;
  color: #334155;
}
.hbh-btn-ticket:hover {
  background: #e2e8f0;
}
.hbh-btn-edit {
  background: #dbeafe;
  color: #1d4ed8;
  margin-left: 6px;
}
.hbh-btn-edit:hover {
  background: #bfdbfe;
}
.hbh-empty {
  text-align: center;
  padding: 56px 20px;
  color: #94a3b8;
}
.hbh-empty-icon {
  font-size: 34px;
  margin-bottom: 10px;
}
.hbh-empty-title {
  font-size: 15px;
  font-weight: 700;
  color: #475569;
}
.hbh-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 16px;
}
.hbh-modal {
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 640px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}
.hbh-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid #f1f5f9;
}
.hbh-modal-header h2 {
  font-size: 16px;
  margin: 0;
  color: #1e293b;
}
.hbh-modal-close {
  border: none;
  background: none;
  font-size: 22px;
  line-height: 1;
  color: #94a3b8;
  cursor: pointer;
}
.hbh-modal-close:hover {
  color: #475569;
}
.hbh-modal-body {
  padding: 22px 24px;
}
.hbh-modal-loading,
.hbh-modal-error {
  text-align: center;
  padding: 40px 0;
  color: #94a3b8;
}
.hbh-modal-error {
  color: #dc2626;
}
.hbh-modal-section {
  border-top: 1px solid #f1f5f9;
  padding-top: 16px;
  margin-top: 16px;
}
.hbh-modal-section:first-child {
  border-top: none;
  padding-top: 0;
  margin-top: 0;
}
.hbh-modal-label {
  font-size: 11px;
  color: #94a3b8;
  margin-bottom: 4px;
}
.hbh-modal-value {
  font-weight: 600;
  color: #1e293b;
  font-size: 14px;
}
.hbh-modal-sub {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}
.hbh-modal-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hbh-modal-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.hbh-modal-price-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hbh-modal-price {
  font-size: 20px;
  font-weight: 700;
  color: #2563eb;
}
.hbh-page-loading {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
  font-size: 14px;
}
/* ==== Edit modal form (redesigned) ==== */
.hbh-edit-modal {
  max-width: 560px;
}
.hbh-edit-header {
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, #eef2ff 0%, #eff6ff 100%);
  border-radius: 14px 14px 0 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.hbh-edit-header-left {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.hbh-edit-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #2563eb;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}
.hbh-edit-header h2 {
  font-size: 16px;
  margin: 0;
  color: #0f172a;
}
.hbh-edit-header-sub {
  font-size: 12px;
  color: #64748b;
  margin-top: 3px;
}
.hbh-edit-header-sub b {
  color: #334155;
}
.hbh-edit-body {
  padding: 22px 24px 24px;
}
.hbh-edit-section-title {
  font-size: 11px;
  letter-spacing: 0.06em;
  color: #94a3b8;
  font-weight: 700;
  margin: 0 0 12px;
  text-transform: uppercase;
}
.hbh-edit-section-title:not(:first-child) {
  margin-top: 22px;
}
.hbh-edit-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 16px;
}
.hbh-edit-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.hbh-edit-field.full {
  grid-column: 1 / -1;
}
.hbh-edit-field label {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 5px;
}
.hbh-edit-field input,
.hbh-edit-field select {
  border: 1.5px solid #e2e8f0;
  border-radius: 9px;
  padding: 10px 12px;
  font-size: 13px;
  color: #1e293b;
  outline: none;
  background: #fbfcfe;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
}
.hbh-edit-field input:hover,
.hbh-edit-field select:hover {
  border-color: #cbd5e1;
}
.hbh-edit-field input:focus,
.hbh-edit-field select:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
  background: #fff;
}
.hbh-edit-field input:disabled,
.hbh-edit-field select:disabled {
  background: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
}
.hbh-edit-amount-wrap {
  position: relative;
}
.hbh-edit-amount-wrap span {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 13px;
  color: #94a3b8;
  font-weight: 600;
}
.hbh-edit-amount-wrap input {
  padding-left: 26px;
}
.hbh-status-pills {
  display: flex;
  gap: 8px;
  grid-column: 1 / -1;
}
.hbh-status-pill {
  flex: 1;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  border-radius: 9px;
  padding: 9px 10px;
  font-size: 12.5px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.15s;
}
.hbh-status-pill:hover:not(:disabled) {
  border-color: #cbd5e1;
}
.hbh-status-pill .dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #cbd5e1;
}
.hbh-status-pill.active-confirmed {
  border-color: #16a34a;
  background: #f0fdf4;
  color: #047857;
}
.hbh-status-pill.active-confirmed .dot { background: #16a34a; }
.hbh-status-pill.active-pending {
  border-color: #d97706;
  background: #fffbeb;
  color: #b45309;
}
.hbh-status-pill.active-pending .dot { background: #d97706; }
.hbh-status-pill.active-cancelled {
  border-color: #dc2626;
  background: #fef2f2;
  color: #b91c1c;
}
.hbh-status-pill.active-cancelled .dot { background: #dc2626; }
.hbh-status-pill:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.hbh-edit-footer {
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
  padding-top: 18px;
  border-top: 1px solid #f1f5f9;
}
.hbh-edit-msg {
  grid-column: 1 / -1;
  font-size: 13px;
  font-weight: 500;
  padding: 10px 14px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.hbh-edit-msg.success {
  background: #d1fae5;
  color: #047857;
}
.hbh-edit-msg.error {
  background: #fee2e2;
  color: #b91c1c;
}
/* ==== Voucher-style ticket modal ==== */
.hbh-voucher {
  background: #fff;
}
.hbh-voucher-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #f1f5f9;
}
.hbh-voucher-brand {
  font-size: 18px;
  font-weight: 800;
  color: #1e293b;
  letter-spacing: 0.02em;
}
.hbh-voucher-brand span {
  color: #2563eb;
}
.hbh-voucher-qr {
  width: 56px;
  height: 56px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}
.hbh-voucher-pnr-row {
  padding: 14px 24px 0;
}
.hbh-voucher-pnr {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
}
.hbh-voucher-status {
  font-size: 13px;
  font-weight: 700;
  margin-top: 4px;
}
.hbh-voucher-status.confirmed { color: #16a34a; }
.hbh-voucher-status.pending { color: #d97706; }
.hbh-voucher-status.cancelled { color: #dc2626; }
.hbh-voucher-box {
  margin: 16px 24px 24px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
}
.hbh-voucher-box-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fafc;
  padding: 10px 16px;
  border-bottom: 1px solid #e2e8f0;
}
.hbh-voucher-box-head-title {
  font-size: 13px;
  font-weight: 700;
  color: #94a3b8;
}
.hbh-voucher-box-head-date {
  font-size: 12px;
  color: #94a3b8;
}
.hbh-voucher-body {
  display: flex;
  gap: 16px;
  padding: 16px;
}
.hbh-voucher-details {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}
.hbh-voucher-row {
  display: flex;
  gap: 8px;
  font-size: 13px;
}
.hbh-voucher-row-label {
  min-width: 130px;
  font-weight: 700;
  color: #1e293b;
}
.hbh-voucher-row-value {
  color: #334155;
}
.hbh-voucher-booked-by {
  width: 150px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  font-size: 11px;
  color: #64748b;
  height: fit-content;
}
.hbh-voucher-booked-by b {
  display: block;
  font-size: 11px;
  color: #1e293b;
  margin-bottom: 6px;
}
.hbh-voucher-booked-by .txn {
  margin-top: 8px;
  font-weight: 700;
  color: #2563eb;
  font-size: 12px;
  word-break: break-all;
}
.hbh-voucher-table-wrap {
  padding: 0 16px 16px;
}
.hbh-voucher-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.hbh-voucher-table th {
  background: #f8fafc;
  text-align: left;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-weight: 700;
}
.hbh-voucher-table td {
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  color: #334155;
}
.hbh-voucher-footer {
  border-top: 1px solid #f1f5f9;
  padding: 20px 24px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
.hbh-voucher-footer-col h4 {
  font-size: 12px;
  color: #1e293b;
  margin: 0 0 8px;
}
.hbh-voucher-footer-col a,
.hbh-voucher-footer-col p {
  display: block;
  font-size: 11px;
  color: #64748b;
  margin-bottom: 6px;
  text-decoration: none;
}
.hbh-voucher-social {
  display: flex;
  gap: 8px;
}
.hbh-voucher-social span {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #1e293b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 11px;
}
.hbh-voucher-copyright {
  border-top: 1px solid #f1f5f9;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
  color: #94a3b8;
}
@media (max-width: 640px) {
  .hbh-page {
    padding-left: 24px;
  }
  .hbh-actions {
    margin-left: 0;
    width: 100%;
  }
  .hbh-stats {
    width: 100%;
    justify-content: space-between;
  }
  .hbh-voucher-body {
    flex-direction: column;
  }
  .hbh-voucher-booked-by {
    width: 100%;
  }
  .hbh-voucher-footer {
    grid-template-columns: 1fr 1fr;
  }
  .hbh-edit-form {
    grid-template-columns: 1fr;
  }
}
  .hbh-logo {
  height: 70px;
  width: auto;
  display: block;
  object-fit: contain;
}

.hbh-voucher-brand {
  display: flex;
  align-items: center;
}
`;

// ==== LIST API — for the table (GetAdminBookingList) ====
// Real response fields: TransactionId, BookingId, PNR, CustomerName, HotelName,
// CityName, CheckInDate, CheckOutDate, Amount, BookingStatus, BookingDate
async function fetchBookingList({ fromDate, toDate, bookingId, pnr, transactionId }) {
  try {
    const res = await fetch(GET_BOOKING_LIST_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        fromDate: fromDate || null,
        toDate: toDate || null,
        bookingId: bookingId || null,
        pnr: pnr || null,
        transactionId: transactionId || null,
      }),
    });
    if (!res.ok) return [];
    const data = await res.json();

    // The API sometimes sends a plain array, sometimes wrapped — handling both
    const list = Array.isArray(data)
      ? data
      : data?.Data || data?.data || data?.BookingList || data?.List || data?.Result || [];

    return list;
  } catch (err) {
    return [];
  }
}

// ==== SINGLE TICKET API — for the voucher modal (old, unchanged) ====
async function fetchTicketById(transactionId) {
  try {
    const res = await fetch(
      `${GET_OFFLINE_TICKET_API}?transactionId=${transactionId}`
    );
    if (!res.ok) return null;
    const data = await res.json();
    if (!data || !data.HotelName) return null;
    return { ...data, TransactionId: data.TransactionId || transactionId };
  } catch (err) {
    return null;
  }
}

// ==== UPDATE BOOKING API — for the edit modal ====
async function updateAdminBooking(payload) {
  console.log("[UpdateAdminBooking] sending payload:", payload);
  try {
    const res = await fetch(UPDATE_BOOKING_API, {
      method: UPDATE_BOOKING_METHOD,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    console.log("[UpdateAdminBooking] HTTP status:", res.status, res.statusText);

    // First pull the raw text and check it — if the backend doesn't send JSON (an HTML error
    // page, or blank), res.json() silently fails and we'd show a wrong message.
    const rawText = await res.text();
    console.log("[UpdateAdminBooking] raw response body:", rawText);

    let data = null;
    try {
      data = rawText ? JSON.parse(rawText) : null;
    } catch (parseErr) {
      console.error("[UpdateAdminBooking] response JSON parse failed:", parseErr);
      return {
        IsSuccess: false,
        Message: `Could not understand the server response (status ${res.status}). Check the console.`,
      };
    }

    if (!res.ok) {
      return {
        IsSuccess: false,
        Message: (data && data.Message) || `Update fail (HTTP ${res.status}).`,
      };
    }

    if (!data) {
      return { IsSuccess: false, Message: "Server se khaali response aaya." };
    }

    return data; // { IsSuccess, Message }
  } catch (err) {
    // This block only runs when fetch itself fails — usually CORS or the network being down
    console.error("[UpdateAdminBooking] fetch threw an error (likely CORS/network):", err);
    return {
      IsSuccess: false,
      Message: "Network/CORS error. Console (F12) mein exact error dekho.",
    };
  }
}

export default function HotelBookingHistory() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [bookingIdFilter, setBookingIdFilter] = useState("");
  const [status, setStatus] = useState("All Status");

  const [bookings, setBookings] = useState([]); // 100% API-fetched, never hardcoded
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(""); // only for real fetch/network errors


  const [ticketModalOpen, setTicketModalOpen] = useState(false);
  const [ticketLoading, setTicketLoading] = useState(false);
  const [ticketError, setTicketError] = useState("");
  const [ticketData, setTicketData] = useState(null);

  // ==== EDIT MODAL STATE ====
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editSaving, setEditSaving] = useState(false);
  const [editMsg, setEditMsg] = useState({ type: "", text: "" }); // type: "success" | "error"
  const [editForm, setEditForm] = useState({
    transactionId: null,
    pnr: "",
    customerName: "",
    checkInDate: "",
    checkOutDate: "",
    amount: "",
    bookingStatus: 4,
    hotelName: "",   // only for display in the modal header, not sent in the API payload
    bookingId: "",   // only for display in the modal header, not sent in the API payload
  });

  // ==== FETCH BOOKING LIST FROM GetAdminBookingList ====
  const loadBookings = useCallback(async (filters) => {
    setLoading(true);
    setLoadError("");
    try {
      const list = await fetchBookingList(filters);
      setBookings(list);
      // NOTE: list.length === 0 is not an error here — it's a valid "no results found"
      // state, handled inside the table with a proper empty-state message.
    } catch (err) {
      setLoadError("Could not load bookings. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const { from, to } = getDefaultDateRange();
    setFromDate(from);
    setToDate(to);
    loadBookings({ fromDate: from, toDate: to, bookingId: null, pnr: null, transactionId: null });
  }, [loadBookings]);

  // ==== CLIENT-SIDE FILTERING (status + bookingId + date range) ====
  // The list API is asked to filter by date/bookingId too, but different backends behave
  // differently (some ignore filters, some return a wider range) — so we always re-filter
  // on the client as well. This also makes the table react live as the user types/changes
  // filters, without needing to press Search again.
  const filteredBookings = bookings.filter((b) => {
    const matchesStatus =
      status === "All Status" ? true : getListStatusLabel(b.BookingStatus) === status;

    const idQuery = bookingIdFilter.trim().toLowerCase();
    const matchesBookingId = idQuery
      ? [b.BookingId, b.PNR, b.CustomerName]
          .filter(Boolean)
          .some((v) => String(v).toLowerCase().includes(idQuery))
      : true;

    let matchesDate = true;
    if (b.CheckInDate && !String(b.CheckInDate).startsWith("0001")) {
      const checkIn = new Date(b.CheckInDate);
      if (!isNaN(checkIn.getTime())) {
        if (fromDate) matchesDate = matchesDate && checkIn >= new Date(fromDate);
        if (toDate) matchesDate = matchesDate && checkIn <= new Date(toDate);
      }
    }

    return matchesStatus && matchesBookingId && matchesDate;
  });

  const totalCount = filteredBookings.length;
  const bookedCount = filteredBookings.filter(
    (b) => getListStatusLabel(b.BookingStatus) === "Confirmed"
  ).length;
  const pendingCount = filteredBookings.filter(
    (b) => getListStatusLabel(b.BookingStatus) === "Pending"
  ).length;

  const handleSearch = () => {
    loadBookings({
      fromDate: fromDate || null,
      toDate: toDate || null,
      bookingId: bookingIdFilter.trim() || null,
      pnr: null,
      transactionId: null,
    });
  };

  const handleReset = () => {
    const { from, to } = getDefaultDateRange();
    setFromDate(from);
    setToDate(to);
    setBookingIdFilter("");
    setStatus("All Status");
    loadBookings({ fromDate: from, toDate: to, bookingId: null, pnr: null, transactionId: null });
  };

  // ==== VIEW TICKET (uses the old single-ticket API, based on transactionId) ====
  const handleViewTicket = async (transactionId) => {
    setTicketModalOpen(true);
    setTicketLoading(true);
    setTicketError("");
    setTicketData(null);

    const data = await fetchTicketById(transactionId);
    if (data) {
      setTicketData(data);
    } else {
      setTicketError("Could not load the ticket. Please try again.");
    }
    setTicketLoading(false);
  };

  const closeModal = () => {
    setTicketModalOpen(false);
    setTicketData(null);
    setTicketError("");
  };

  // ==== EDIT BOOKING — prefills the form from the row data and opens the modal ====
  const handleEditClick = (b) => {
    setEditMsg({ type: "", text: "" });
    setEditForm({
      transactionId: b.TransactionId,
      pnr: b.PNR || "",
      customerName: b.CustomerName || "",
      checkInDate: toInputDate(b.CheckInDate),
      checkOutDate: toInputDate(b.CheckOutDate),
      amount: b.Amount ?? "",
      bookingStatus: b.BookingStatus ?? 4,
      hotelName: b.HotelName || "",
      bookingId: b.BookingId || "",
    });
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    if (editSaving) return; // don't close mid-save while it's still saving
    setEditModalOpen(false);
    setEditMsg({ type: "", text: "" });
  };

  const handleEditFieldChange = (field, value) => {
    setEditForm((prev) => ({ ...prev, [field]: value }));
  };

  // ==== SUBMIT EDIT — UpdateAdminBooking API call ====
  const handleEditSubmit = async () => {
    setEditSaving(true);
    setEditMsg({ type: "", text: "" });

    const payload = {
      transactionId: editForm.transactionId,
      pnr: editForm.pnr.trim(),
      customerName: editForm.customerName.trim(),
      checkInDate: editForm.checkInDate,
      checkOutDate: editForm.checkOutDate,
      amount: Number(editForm.amount) || 0,
      bookingStatus: Number(editForm.bookingStatus),
    };

    const res = await updateAdminBooking(payload);

    if (res.IsSuccess) {
      setEditMsg({ type: "success", text: res.Message || "Booking updated successfully." });

      // Update the local table row immediately too, without refetching
      setBookings((prev) =>
        prev.map((b) =>
          b.TransactionId === editForm.transactionId
            ? {
                ...b,
                PNR: payload.pnr,
                CustomerName: payload.customerName,
                CheckInDate: payload.checkInDate,
                CheckOutDate: payload.checkOutDate,
                Amount: payload.amount,
                BookingStatus: payload.bookingStatus,
              }
            : b
        )
      );

      // Close the modal automatically after 1 second
      setTimeout(() => {
        setEditModalOpen(false);
        setEditMsg({ type: "", text: "" });
      }, 1000);
    } else {
      setEditMsg({ type: "error", text: res.Message || "Update failed. Please try again." });
    }

    setEditSaving(false);
  };

  // ==== EXPORT EXCEL (CSV) — from real fetched data only ====
  const handleExportExcel = () => {
    const headers = [
      "#",
      "Hotel Name",
      "Booking ID",
      "Passenger",
      "Checkin",
      "Checkout",
      "Status",
    ];
    const rows = filteredBookings.map((b, idx) => [
      idx + 1,
      b.HotelName,
      b.BookingId,
      b.CustomerName,
      formatDate(b.CheckInDate),
      formatDate(b.CheckOutDate),
      getListStatusLabel(b.BookingStatus),
    ]);

    const csvContent =
      headers.join(",") +
      "\n" +
      rows.map((r) => r.map((cell) => `"${cell ?? ""}"`).join(",")).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "hotel_booking_history.csv";
    link.click();
  };

  return (
    <div className="hbh-page">
      <Sidebar/>
      <style>{HBH_STYLES}</style>

      {/* Header */}
      <div className="hbh-header">
        <div>
          <h1>Hotel Bookings</h1>
          <p>Real-time overview of all hotel reservations</p>
        </div>
        <div className="hbh-stats">
          <div className="hbh-stat-card">
            <div className="hbh-stat-label">TOTAL</div>
            <div className="hbh-stat-value total">{totalCount}</div>
          </div>
          <div className="hbh-stat-card">
            <div className="hbh-stat-label">BOOKED</div>
            <div className="hbh-stat-value booked">{bookedCount}</div>
          </div>
          <div className="hbh-stat-card">
            <div className="hbh-stat-label">PENDING</div>
            <div className="hbh-stat-value pending">{pendingCount}</div>
          </div>
        </div>
      </div>

      {/* Search & Filter */}
      <div className="hbh-card hbh-filter-card">
        <div className="hbh-filter-title">SEARCH &amp; FILTER</div>
        <div className="hbh-filter-row">
          <div className="hbh-field">
            <label>From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="hbh-field">
            <label>To Date</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="hbh-field">
            <label>Booking ID</label>
            <input
              type="text"
              placeholder="e.g. TJ2088182184089"
              value={bookingIdFilter}
              onChange={(e) => setBookingIdFilter(e.target.value)}
            />
          </div>
          <div className="hbh-field">
            <label>Status</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option>All Status</option>
              <option>Confirmed</option>
              <option>Pending</option>
              <option>Cancelled</option>
            </select>
          </div>

          <div className="hbh-actions">
            <button
              className="hbh-btn hbh-btn-primary"
              onClick={handleExportExcel}
              disabled={loading || filteredBookings.length === 0}
            >
              📊 Export Excel
            </button>
            <button
              className="hbh-btn hbh-btn-primary"
              onClick={handleSearch}
              disabled={loading}
            >
              🔍 {loading ? "Searching..." : "Search"}
            </button>
            <button
              className="hbh-btn hbh-btn-outline"
              onClick={handleReset}
              disabled={loading}
            >
              Reset
            </button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="hbh-card hbh-table-card">
        <div className="hbh-table-header">
          <div>
            <div className="hbh-table-count">
              <b>{filteredBookings.length}</b> bookings found
            </div>
          </div>
          <div className="hbh-table-hint">
            Scroll horizontally on smaller screens
          </div>
        </div>

        {loading ? (
          <div className="hbh-page-loading">Loading bookings from API...</div>
        ) : loadError ? (
          <div className="hbh-page-loading">{loadError}</div>
        ) : (
          <div className="hbh-table-wrap">
            <table className="hbh-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>HOTEL</th>
                  <th>BOOKING ID</th>
                  <th>PASSENGER</th>
                  <th>CHECKIN</th>
                  <th>CHECKOUT</th>
                  <th>STATUS</th>
                  <th>TICKET</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {filteredBookings.map((b, idx) => (
                  <tr key={b.TransactionId || b.BookingId || idx}>
                    <td className="hbh-idx">{idx + 1}</td>
                    <td className="hbh-hotel-name">{b.HotelName}</td>
                    <td>
                      <span className="hbh-booking-link">
                        {b.BookingId}
                      </span>
                    </td>
                    <td>{b.CustomerName}</td>
                    <td>{formatDate(b.CheckInDate)}</td>
                    <td>{formatDate(b.CheckOutDate)}</td>
                    <td>
                      <span
                        className={
                          badgeClass[getListStatusLabel(b.BookingStatus)] ||
                          "hbh-badge hbh-badge-pending"
                        }
                      >
                        {getListStatusLabel(b.BookingStatus)}
                      </span>
                    </td>
                    <td>
                      <button
                        className="hbh-row-btn hbh-btn-ticket"
                        onClick={() => handleViewTicket(b.TransactionId)}
                      >
                        Ticket
                      </button>
                    </td>
                    <td>
                      <button
                        className="hbh-row-btn hbh-btn-edit"
                        onClick={() => handleEditClick(b)}
                      >
                        ✏️ Edit
                      </button>
                    </td>
                  </tr>
                ))}

                {filteredBookings.length === 0 && (
                  <tr>
                    <td colSpan={9} className="hbh-empty">
                      <div className="hbh-empty-icon">🧳</div>
                      <div className="hbh-empty-title">No bookings found</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Edit Modal */}
      {editModalOpen && (
        <div className="hbh-modal-overlay" onClick={closeEditModal}>
          <div className="hbh-modal hbh-edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="hbh-edit-header">
              <div className="hbh-edit-header-left">
                <div className="hbh-edit-header-icon">✏️</div>
                <div>
                  <h2>Edit Booking</h2>
                  <div className="hbh-edit-header-sub">
                    {editForm.hotelName && <><b>{editForm.hotelName}</b> · </>}
                    {editForm.bookingId || "—"}
                  </div>
                </div>
              </div>
              <button className="hbh-modal-close" onClick={closeEditModal}>
                &times;
              </button>
            </div>

            <div className="hbh-edit-body">
              <div className="hbh-edit-form">
                {editMsg.text && (
                  <div className={`hbh-edit-msg ${editMsg.type}`}>
                    {editMsg.type === "success" ? "✅" : "⚠️"} {editMsg.text}
                  </div>
                )}

                <div className="hbh-edit-field full">
                  <div className="hbh-edit-section-title">Guest &amp; Reference</div>
                </div>

                <div className="hbh-edit-field">
                  <label>PNR</label>
                  <input
                    type="text"
                    value={editForm.pnr}
                    onChange={(e) => handleEditFieldChange("pnr", e.target.value)}
                    disabled={editSaving}
                  />
                </div>

                <div className="hbh-edit-field">
                  <label>Customer Name</label>
                  <input
                    type="text"
                    value={editForm.customerName}
                    onChange={(e) => handleEditFieldChange("customerName", e.target.value)}
                    disabled={editSaving}
                  />
                </div>

                <div className="hbh-edit-field full">
                  <div className="hbh-edit-section-title">Stay Details</div>
                </div>

                <div className="hbh-edit-field">
                  <label>📅 Check In</label>
                  <input
                    type="date"
                    value={editForm.checkInDate}
                    onChange={(e) => handleEditFieldChange("checkInDate", e.target.value)}
                    disabled={editSaving}
                  />
                </div>

                <div className="hbh-edit-field">
                  <label>📅 Check Out</label>
                  <input
                    type="date"
                    value={editForm.checkOutDate}
                    onChange={(e) => handleEditFieldChange("checkOutDate", e.target.value)}
                    disabled={editSaving}
                  />
                </div>

                <div className="hbh-edit-field">
                  <label>Amount</label>
                  <div className="hbh-edit-amount-wrap">
                    <span>₹</span>
                    <input
                      type="number"
                      value={editForm.amount}
                      onChange={(e) => handleEditFieldChange("amount", e.target.value)}
                      disabled={editSaving}
                    />
                  </div>
                </div>

                <div className="hbh-edit-field full">
                  <div className="hbh-edit-section-title">Booking Status</div>
                </div>

                <div className="hbh-status-pills">
                  {EDIT_STATUS_OPTIONS.map((opt) => {
                    const isActive = Number(editForm.bookingStatus) === opt.value;
                    const activeClass =
                      opt.label === "Confirmed"
                        ? "active-confirmed"
                        : opt.label === "Pending"
                        ? "active-pending"
                        : "active-cancelled";
                    return (
                      <button
                        type="button"
                        key={opt.value}
                        className={`hbh-status-pill ${isActive ? activeClass : ""}`}
                        onClick={() => handleEditFieldChange("bookingStatus", opt.value)}
                        disabled={editSaving}
                      >
                        <span className="dot" />
                        {opt.label}
                      </button>
                    );
                  })}
                </div>

                <div className="hbh-edit-footer">
                  <button
                    className="hbh-btn hbh-btn-outline"
                    onClick={closeEditModal}
                    disabled={editSaving}
                  >
                    Cancel
                  </button>
                  <button
                    className="hbh-btn hbh-btn-primary"
                    onClick={handleEditSubmit}
                    disabled={editSaving}
                  >
                    {editSaving ? "Updating..." : "💾 Update Booking"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Ticket Modal — Voucher design (from the old single-ticket API) */}
      {ticketModalOpen && (
        <div className="hbh-modal-overlay" onClick={closeModal}>
          <div className="hbh-modal hbh-voucher" onClick={(e) => e.stopPropagation()}>
            <div className="hbh-modal-header">
              <h2>Hotel Voucher</h2>
              <button className="hbh-modal-close" onClick={closeModal}>
                &times;
              </button>
            </div>

            {ticketLoading && (
              <div className="hbh-modal-loading">Loading ticket...</div>
            )}

            {ticketError && (
              <div className="hbh-modal-error">{ticketError}</div>
            )}

            {!ticketLoading && !ticketError && ticketData && (
              <>
                {/* Top bar: brand + QR placeholder */}
             <div className="hbh-voucher-topbar">
  <div className="hbh-voucher-brand">
    <img
      src="/tripji.png"
      alt="TripJi Logo"
      className="hbh-logo"
    />
  </div>

  <div className="hbh-voucher-qr" />
</div>
                {/* PNR + Status */}
                <div className="hbh-voucher-pnr-row">
                  <div className="hbh-voucher-pnr">
                    Hotel PNR: {ticketData.TicketNumber}
                  </div>
                  <div
                    className={
                      "hbh-voucher-status " +
                      (getTicketStatusLabel(ticketData.BookingStatus) === "Confirmed"
                        ? "confirmed"
                        : getTicketStatusLabel(ticketData.BookingStatus) === "Pending"
                        ? "pending"
                        : "cancelled")
                    }
                  >
                    Status:{" "}
                    {getTicketStatusLabel(ticketData.BookingStatus) === "Confirmed"
                      ? "Booking Confirmed"
                      : getTicketStatusLabel(ticketData.BookingStatus) === "Pending"
                      ? "Booking Pending"
                      : "Booking Cancelled"}
                  </div>
                </div>

                {/* Main details box */}
                <div className="hbh-voucher-box">
                  <div className="hbh-voucher-box-head">
                    <div className="hbh-voucher-box-head-title">
                      Hotel Ticket
                    </div>
                    <div className="hbh-voucher-box-head-date">
                      Booking Date: {formatDate(ticketData.BookingDate)}
                    </div>
                  </div>

                  <div className="hbh-voucher-body">
                    <div className="hbh-voucher-details">
                      <div className="hbh-voucher-row">
                        <div className="hbh-voucher-row-label">
                          DESTINATION:
                        </div>
                        <div className="hbh-voucher-row-value">
                          {ticketData.CityName}, {ticketData.CountryName}
                        </div>
                      </div>
                      <div className="hbh-voucher-row">
                        <div className="hbh-voucher-row-label">
                          HOTEL NAME:
                        </div>
                        <div className="hbh-voucher-row-value">
                          {ticketData.HotelName}
                        </div>
                      </div>
                      <div className="hbh-voucher-row">
                        <div className="hbh-voucher-row-label">
                          HOTEL ADDRESS:
                        </div>
                        <div className="hbh-voucher-row-value">
                          {ticketData.HotelAddress}
                        </div>
                      </div>
                      <div className="hbh-voucher-row">
                        <div className="hbh-voucher-row-label">CHECK IN:</div>
                        <div className="hbh-voucher-row-value">
                          {formatDate(ticketData.CheckinDate)}
                        </div>
                      </div>
                      <div className="hbh-voucher-row">
                        <div className="hbh-voucher-row-label">
                          CHECK OUT:
                        </div>
                        <div className="hbh-voucher-row-value">
                          {formatDate(ticketData.CheckoutDate)}
                        </div>
                      </div>
                      <div className="hbh-voucher-row">
                        <div className="hbh-voucher-row-label">
                          NO. OF ROOMS:
                        </div>
                        <div className="hbh-voucher-row-value">
                          {ticketData.NumberOfRooms}
                        </div>
                      </div>
                      <div className="hbh-voucher-row">
                        <div className="hbh-voucher-row-label">ADULTS:</div>
                        <div className="hbh-voucher-row-value">
                          {ticketData.NumberOfAdults}
                        </div>
                      </div>
                      <div className="hbh-voucher-row">
                        <div className="hbh-voucher-row-label">
                          CHILDREN:
                        </div>
                        <div className="hbh-voucher-row-value">
                          {ticketData.NumberOfChild}
                        </div>
                      </div>
                    </div>

                    <div className="hbh-voucher-booked-by">
                      <b>BOOKED BY:</b>
                      TripCaliber
                      <div className="txn">
                        TXN ID: {ticketData.TicketNumber}
                      </div>
                    </div>
                  </div>

                  {/* Room table */}
                  <div className="hbh-voucher-table-wrap">
                    <table className="hbh-voucher-table">
                      <thead>
                        <tr>
                          <th>Room No#</th>
                          <th>Room Type/Board</th>
                          <th>Guest Name</th>
                          <th>Adults</th>
                          <th>Children</th>
                          <th>Room Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>ROOM 1</td>
                          <td>{ticketData.RoomType || "-"}</td>
                          <td>{ticketData.PassengerName}</td>
                          <td>{ticketData.NumberOfAdults}</td>
                          <td>{ticketData.NumberOfChild}</td>
                          <td>
                            {Number(ticketData.TotalPrice || 0).toLocaleString(
                              "en-IN"
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Footer */}
                <div className="hbh-voucher-footer">
                  <div className="hbh-voucher-footer-col">
                    <h4>Company</h4>
                    <a href="#">About Us</a>
                    <a href="#">Blog</a>
                    <a href="#">Privacy Policy</a>
                    <a href="#">Terms of Use</a>
                    <a href="#">Refund &amp; Cancellation Policy</a>
                  </div>
                  <div className="hbh-voucher-footer-col">
                    <h4>Services</h4>
                    <a href="#">Flight Booking</a>
                    <a href="#">Hotel Booking</a>
                  </div>
                  <div className="hbh-voucher-footer-col">
                    <h4>Help And Support</h4>
                    <a href="#">Contact Us</a>
                    <a href="#">Agent Login</a>
                  </div>
                  <div className="hbh-voucher-footer-col">
                    <h4>Keep In Touch</h4>
                    <div className="hbh-voucher-social">
                      <span>f</span>
                      <span>x</span>
                      <span>in</span>
                      <span>yt</span>
                    </div>
                  </div>
                </div>

                <div className="hbh-voucher-copyright">
                  <span>© 2025 - 2026 TripCaliber</span>
                  <span>Powered By: Naman Technolab</span>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      <Footer2/>
    </div>
  );
}